import { ArrowCircleRightTwoTone } from "@mui/icons-material";
import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useCallback,
} from "react";
import { useParams } from "react-router-dom";
import APIRequest from "../../../services/services";
import Page from "../../Page";
import likeUnlike from "../../../assets/images/Rpost/review.png";
import likelike from "../../../assets/images/Rpost/Rdocs-like.png";
import Unlike from "../../../assets/images/Rpost/Rdocs-Dislike.png";
import Confidential from "../../../assets/images/Rpost/confidential.png";
import print from "../../../assets/images/Rpost/time2.png";
import HeaderWithMobileDesign from "../../../Shared/Header/Default/HeaderWithMobileDesign";
import PdfImg from "../../../assets/images/u70.png";
import RdocsWhite from "../../../../src/assets/images/RDocs-White.png";
import RpostPowered from "../../../../src/assets/images/RPost-powered.png";
import timerpng from "../../../assets/images/Rpost/time2.png";
import Footer from "../../../Shared/Footer/Default/Footer";
import Alert from "../../Controls/Alerts/Alerts";
import "./DocumentRPD.css";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../Controls/LoadingSpinner/LoadingSpinner";
import TimerDisplay from "../../../components/Controls/TimerComponent/TimerDisplay";
import moment from "moment";
import { useCookies } from "react-cookie";
import { Translations } from "../../../Shared/Translation/Translations";
import DocPage from "../../DocPage";
import { Zoom } from "@mui/material";
import styled from "@emotion/styled";
import WhitePage from "../../Controls/PageCreation/WhitePage";
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
let pageNumber = 1;
let browserName = "";
let tempRecipientId = 0;
let documentName = "";
let timerCount = 0;
let rdocsLevel = "";
let handleClose = 0;
let readerPageUrl = "/read/";
let max_count = 900;
let waitcount = 0;
let randomNumRpost = Math.floor(Math.random() * 90000) + 10000;
let SessionpopuupDisable = 0,
  noInternetval = 0;
let NoInternetRemainingVal = 0;
let tCount = 0;
let imgSetTimer;
let currentGlobalpage;
function DocumentNew() {
  let start = 0;

  let lastVote = -1;

  let sharevoting = 0;
  let locImgURLDataArray = [];
  const [show, setShow] = useState(false);
  const [currentpage, setPage] = useState(1);
  const [currentTempPage, setTempPage] = useState("1");
  const [zoomClass, setZoomClass] = useState("rm-transform1");
  const [zoomClassHeight, setZoomClassHeight] = useState("");
  const [zoomClassFull, setZoomClassFull] = useState("");
  const [zoomClassDiv, setZoomClassDiv] = useState("");
  const [zoomClassDisabled, setZoomClassDisabled] = useState("");
  const [zoomText, setZoomText] = useState("100%");
  const [zoomValue, setZoomValue] = useState(6);
  const [zoomPercentage, setZoomPercentage] = useState(100);
  const [Loadingmessage, setLoadingmessage] = useState(0);
  const zoomOptions = [
    "100%",
    "100%",
    "100%",
    "50%",
    "75%",
    "100%",
    "125%",
    "150%",
  ];
  const [totalPages, setTotalPages] = useState(1);
  let totalPagesCount = 1;
  const [count, setCount] = useState(0);
  const [countOffLineOnline, setCountOffLineOnline] = useState(0);
  const { documentId, openId } = useParams();
  const [showSlide, setShowResults] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [imgURL, setImgURL] = useState("");
  const [imgURLDataArray, setImgURLDataArray] = useState([]);
  const [imgURLData, setImgURLData] = useState("");
  const [pageLevelRestriction, setPageLevelRestriction] = useState(false);
  const [pageRestrictedCount, setPageRestrictedCount] = useState(0);
  const [pageRestrictedFlag, setPageRestrictedFlag] = useState(false);
  const [localPageLevelRestriction, setLocalPageLevelRestriction] = useState(false);
  const [documentLevelRestriction, setDocumentLevelRestriction] = useState(false);
  const [documentLevelRestrictionDetails, setDocumentLevelRestrictionDetails] = useState([]);

  let stopIndicator = false;

  const [imgBlankData] = useState("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");
  const idleTimeRef = useState(null);
  const [docNote, setDocNote] = useState("");
  const [senderEmailAddress, setSenderEmailAddress] = useState("");
  const [loginEmailAddress, setLoginEmailAddress] = useState("");
  const [userlist, setUserList] = useState([]);
  const [sendEmailButton, setSendEmailButton] = useState("");
  const [identifyLeakerText, setIdentifyLeakerText] = useState("");
  const [identifyLeakerLoopCount, setIdentifyLeakerLoopCount] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]);
  const [identifyLeakerEmailLoopCount, setIdentifyLeakerEmailLoopCount] =
    useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
  // const [stegVal1, setstegVal1] = useState("");
  // const [stegVal2, setstegVal2] = useState("");
  // const [stegVal3, setstegVal3] = useState("");
  // const [stegVal4, setstegVal4] = useState("");
  // const [stegVal5, setstegVal5] = useState("");
  // const [stegVal6, setstegVal6] = useState("");
  // const [stegVal7, setstegVal7] = useState("");
  // const [stegVal8, setstegVal8] = useState("");
  const [isDistributionList, setisDistributionList] = useState(false);
  const [isSideNote, setisSideNote] = useState(false);
  const [isVoting, setisVoting] = useState(false);
  const [openVoting, setOpenVoting] = useState(false);
  const [lastVoting, setlastVoting] = useState(false);
  const [recipientId, setrecipientId] = useState("");
  const [isVoted, setisVoted] = useState(false);
  const [VotedValue, setVotedValue] = useState(-1);
  const [issharevoting, setsharevoting] = useState(false);
  const [isPrint, setisPrint] = useState(false);
  const [allowResponsesTo, setAllowResponsesTo] = useState("");
  const [isallowResponsesTo, setisAllowResponsesTo] = useState(false);
  const [defaultToAddress, setdefaultToAddress] = useState("");
  const [pageWidthValue, setpageWidthValue] = useState("");
  const [pageHeightValue, setpageHeightValue] = useState("");
  const [orignalPageWidth, setOrignalPageWidth] = useState("");
  const [orignalPageHeight, setOrignalPageHeight] = useState("");
  const [orignalMainPageWidth, setOrignalMainPageWidth] = useState("");
  const [orignalMainPageHeight, setOrignalMainPageHeight] = useState("");
  const [masterOrignalPageWidth, setMasterOrignalPageWidth] = useState("");
  const [masterOrignalPageHeight, setMasterOrignalPageHeight] = useState("");
  const [pageWidthLeftValue, setpageWidthLeftValue] = useState("");
  //const printableAreaRef = React.useRef<HTMLDivElement>(null);

  //const [replyTo, setreplyTo] = useState("");
  const [replySubject, setreplySubject] = useState("");
  const [replymessage, setreplymessage] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [isSessionId, setisSessionId] = useState(false);
  const history = useNavigate();
  const [Senderaddressitems, setItems] = useState([]);
  const componentRef = useRef();
  const [pdfViewData, setpdfData] = useState("");
  const [modelopen, setMpdelOpen] = useState(false);
  const [modelMessage, setModelMessage] = useState("");
  const [defaultSubject, setdefaultSubject] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [disablePageNavigationButtons, setDisablePageNavigationButtons] =
    useState(false);
  const [PageviewModelOpen, setPageviewModelOpen] = useState(false);
  const [timerValue, settimerValue] = useState("5 minute(s) & 00 second(s).");
  const [languageTranslations, setLanguageTranslations] = [];
  const [imageResolution, setImageResolution] = useState(150);

  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [Reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_RPDYouHaveBeenInactive, setReader_RPDYouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");
  const [Reader_InternetConnectProblem, setReader_InternetConnectProblem] =
    useState("");
  const [
    Reader_ConnectivityReauthenticate,
    setReader_ConnectivityReauthenticate,
  ] = useState("");
  const [Reader_AuthenticatingPleaseWait, setReader_AuthenticatingPleaseWait] =
    useState("");
  const [
    Reader_RequestingPassCodePleaseWait,
    setReader_RequestingPassCodePleaseWait,
  ] = useState("");
  const [
    Reader_ReplyToDocumentPleaseWait,
    setReader_ReplyToDocumentPleaseWait,
  ] = useState("");
  const [Reader_PrintDocumentPleaseWait, setReader_PrintDocumentPleaseWait] =
    useState("");
  const [
    Reader_NavigatingBnPagesPleaseWait,
    setReader_NavigatingBnPagesPleaseWait,
  ] = useState("");
  const [API_SubjectMsg, setAPI_SubjectMsg] = useState("");
  const [Reader_EmailBodyMsg, setReader_EmailBodyMsg] = useState("");
  const [Reader_NoUnitbalanceMessage, setReader_NoUnitbalanceMessage] =
    useState("");
  const [Reader_BotInfoMessage, setReader_BotInfoMessage] = useState("");
  const [Reader_robot, setReader_robot] = useState("");
  const [Reader_BotVerifiedMessage, setReader_BotVerifiedMessage] =
    useState("");
  const [Reader_Botverified, setReader_Botverified] = useState("");
  const [Reader_YouDontHaveAccess, setReader_YouDontHaveAccess] = useState("");
  const [Reader_YouDontHaveAccessToRequested, setReader_YouDontHaveAccessToRequested] = useState("");
  const [timerText, settimertimerText] = useState("You will be logged out in ");
  const [Reader_viewTime, setReader_viewTime] = useState("");
  const Container = styled.div({
    width: "100%",
    marginTop: "62px",
    // margin: 'auto',
    padding: "0px",
    paddingTop: "65px",
    paddingBottom: "5px",
  });

  const Img = styled.img({
    width: pageWidthValue,
    height: pageHeightValue,
    objectFit: "cover",
  });
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [noInternetImg, setnoInternetImg] = useState(
    "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"
  );
  const [imgLockData] = useState("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");
  const [minutesVal, setMinutesVal] = useState(0);
  const [secondsVal, setSecondsVal] = useState(0);
  const [Reader_secondsSmall, setReader_secondsSmall] = useState("");

  const [Reader_minutesSmall, setReader_minutesSmall] = useState("");
  const [Reader_YouWillbeLoggedOutIn, setReader_YouWillbeLoggedOutIn] =
    useState("");
  const [Reader_AllowedPagesOnly, setReader_AllowedPagesOnly] =
    useState("");
    const [Reader_SendingYourReply, setReader_SendingYourReply] = useState("");
  const [Reader_LoadingPleaseWait,setReader_LoadingPleaseWait] = useState("");
  const totalPagesRef = useRef();
  let logout = true,
    logoutWarnTime = 300,
    timer;
  let isSessionEndedForUser = false;
  const timeTrackRef = useRef(null);
  const timeTrackBackRef = useRef(null);
  const timeTrackYouDontHaveAccessRef = useRef(null);
  const [Reader_RPostviewTime, setRPostReader_viewTime] = useState("");
  window.history.forward();
  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      window.history.go(1);
    });
  }, []);

  useEffect(() => { }, [identifyLeakerText]);
  useEffect(() => {
    if (imgURL == "") {
      setLoadingmessage(0);
      setOpenLoader(true);
      ValidatePageViewAccess(0, false);
      handlePageNavigation(0, 5, false);
      loadNextPreviousPages(0);
    }
  }, []);

  window.addEventListener("popstate", (e) => {
    window.history.go(0);
  });

  useEffect(() => {
    window.addEventListener("offline", () => {
      setOnlineStatus(false);
      noInternetval = 1;
    });

    window.addEventListener("online", () => {
      setOnlineStatus(true);
      noInternetval = 0;
    });
  }, []);

  useEffect(() => {
    var sessionStartDate = null;

    document.addEventListener(
      "visibilitychange",
      function () {
        if (document.hidden && document.visibilityState == "hidden")
          sessionStartDate = new Date();
        else if (
          !document.hidden &&
          document.visibilityState == "visible" &&
          sessionStartDate != null
        ) {
          var sessionEndDate = new Date();
          var difference = (sessionEndDate - sessionStartDate) / 1000 / 2;
          timerCount = timerCount + difference;
          //console.log(timerCount);
        }
      },
      false
    );

    // }
    startTimer();
    document.addEventListener(
      "scroll",
      function () {
        resetTimer();
      },
      false
    );
    window.oncontextmenu = function (e) {
      e.preventDefault();
    };
    document.onkeydown = function (e) {
      resetTimer();
      var key = e.key || e.keyCode;
      var alt = document.all ? e.altKey : e.modifiers & e.ALT_MASK;
      key = window.event.keyCode;
      if (window.event.altKey && key == 70) {
        e.preventDefault();
      }

      if (
        key == "F12" ||
        (key == 9 && SessionpopuupDisable == 1) ||
        noInternetval == 1
      ) {
        return false;
      } else if (key == 123) {
        return false;
      } else if (
        (e.ctrlKey && e.shiftKey && key == 73) ||
        (e.ctrlKey && e.shiftKey && key == 74)
      ) {
        return false;
      }
    };
    document.addEventListener(
      "keypress",
      function (event) {
        resetTimer();
        var key = event.key || event.keyCode;

        if (key == 123) {
          return false;
        } else if (
          (event.ctrlKey && event.shiftKey && key == 73) ||
          (event.ctrlKey && event.shiftKey && key == 74)
        ) {
          return false;
        }
      },
      false
    );

    document.onkeypress = function (event) {
      event = event || window.event;
      if (event.keyCode == 123) {
        return false;
      } else if (
        (event.ctrlKey && event.shiftKey && event.keyCode == 73) ||
        (event.ctrlKey && event.shiftKey && event.keyCode == 74)
      ) {
        return false;
      }
    };

    let localSessionId = sessionStorage.getItem("session_" + documentId);
    if (localSessionId == "" || localSessionId == null) {
      setisSessionId(false);
      const url = `${process.env.REACT_APP_API}/status/${documentId}`;
      fetch(url, {
        method: "Get",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          let type = result.data.documentType;
          let fileName = result.data.fileName;
          if (type == 1) {
            history(`/Xerox/ReaderAccess/${documentId}/${fileName}`);
          } else {
            history(`/Default/ReaderAccess/${documentId}/${fileName}`);
          }
        });
    } else {
      if (!navigator.onLine) {
        history(`/Default/NoInternet/${documentId}`);
      }
      setisSessionId(true);
    }
    // console.log(openId);
    // console.log(documentId);
    localStorage.setItem("openId", openId);
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null
    ) {
      const getImageCount = async () => {
        if (
          sessionStorage.getItem("session_" + documentId) != "" &&
          sessionStorage.getItem("session_" + documentId) != null
        ) {
          const url = `${process.env.REACT_APP_API}/images/${documentId}`;
          let json;

          try {
            var res = await fetch(url);
            json = await res.json();
          } catch (error) {
            console.log(error);
            if (!navigator.onLine) {
              history(`/Default/NoInternet/${documentId}`);
            }

            return () => { };
          }
          setCount(json.imageCount);
          setImageResolution(json.imageResolution);
          console.log("image" + json.imageCount);
        }
      };
      getRpddata();
      getImageCount();
    }
  }, [documentId]);
useEffect(() => {
  if (timeTrackYouDontHaveAccessRef.current) {
      clearTimeout(timeTrackYouDontHaveAccessRef.current);
      timeTrackYouDontHaveAccessRef.current= true;
  }
  timeTrackYouDontHaveAccessRef.current= setTimeout(() => {
  if(pageRestrictedCount > 1 && pageRestrictedFlag == true)
  {
    setPageRestrictedCount(pageRestrictedCount-1);
  }
  else{
    setPageRestrictedFlag(false);
    setPageRestrictedCount(0);
  }
}, 1000);}, [pageRestrictedCount]);
  useEffect(() => {
    if (timeTrackBackRef.current) {
      clearInterval(timeTrackBackRef.current);
      timeTrackBackRef.current = null;
    }
    timeTrackBackRef.current = setInterval(TimeCalulation, 1000);
    return () => {
      clearInterval(timeTrackBackRef.current);
      timeTrackBackRef.current = null;
    }
  }, []);
  useEffect(() => {
    if (timeTrackRef.current) {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
    timeTrackRef.current = setInterval(() => {
      check(60, "", true);
    }, 60000);
    return () => {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
  }, []);

  const handleChkChange = (e) => {
    setLocalPageLevelRestriction(e.target.checked)
  }
  function TimeCalulation() {
    if (tCount > 60) {
      tCount = 0;
    }
    tCount = tCount + 1;
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      //check(tCount, currentGlobalpage);
      if (
        sessionStorage.getItem("session_" + documentId) != "" &&
        sessionStorage.getItem("session_" + documentId) != null &&
        window.location.href.toLowerCase().indexOf(readerPageUrl) > -1
      ) {
        if (waitcount == 0 && noInternetval == 0) {
          if (timeTrackRef.current) {
            clearInterval(timeTrackRef.current);
            timeTrackRef.current = null;
          }

          console.log(pageNumber);
          start += 1;
          let count = start;
          const url = `${process.env.REACT_APP_API}/docs/track1`;
          handleClose = 0;
          var rpdreadInfo = {
            documentId: documentId,
            id: openId,
            ActivityTime: tCount == undefined ? 60 : tCount,
            client: browserName,
            RecipientId: tempRecipientId,
            CurrentPage: !currentGlobalpage ? pageNumber : currentGlobalpage,
          };
          const success = navigator.sendBeacon(
            url,
            JSON.stringify(rpdreadInfo)
          );

          // Log if the beacon was queued for sending
          if (success) {
            console.log("Beacon queued successfully");
          } else {
            console.log("Beacon failed to queue");
          }
        }
      }
      return; // For older browsers
    };
    // Add the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  function handleUsePageOnload(flag) {
    let pageInfo = document.getElementById("page");
    //let mainPageInfo = document.getElementById("mainPageView");
    let mainPageInfo = document.getElementById("rpdBody");
    mainPageInfo.style.backgroundColor = "#d2d3d7";
    if (flag == 0) {
      setZoomValue(6);
      setZoomPercentage(100);
      setZoomText("100%");
    }

    // if (pageInfo != null && (orignalPageHeight == "" || flag !=1)) {
    //   setOrignalPageWidth(pageInfo.clientWidth);
    //   setOrignalPageHeight(pageInfo.clientHeight);
    //   console.log("page: pageInfo.width:" + pageInfo.clientWidth);
    //   console.log("page: pageInfo.height:" + pageInfo.clientHeight);
    // }
    // if (mainPageInfo != null) {
    //   setOrignalMainPageWidth(mainPageInfo.clientWidth);
    //   setOrignalMainPageHeight(mainPageInfo.clientHeight - 63 - 102);
    //   console.log("load: mainPageInfo.width:" + mainPageInfo.clientWidth);
    //   console.log("load: mainPageInfo.height:" + mainPageInfo.clientHeight);
    // }
    if (mainPageInfo != null && (orignalMainPageHeight == "" || flag != 1)) {
      setOrignalMainPageWidth(mainPageInfo.clientWidth);
      setOrignalMainPageHeight(mainPageInfo.clientHeight - 63 - 102);
      // setOrignalMainPageHeight(mainPageInfo.clientHeight - 168);
      console.log("load: mainPageInfo.width:" + mainPageInfo.clientWidth);
      console.log("load: mainPageInfo.height:" + mainPageInfo.clientHeight);
    }
    if (pageInfo != null && (orignalPageHeight == "" || flag != 1)) {
      let pageInfoHeight = pageInfo.clientHeight;
      let pageInfoWidth = pageInfo.clientWidth;
      console.log("master1 pgeheight : " + pageInfoHeight);
      console.log("master2 pagewidth : " + pageInfoWidth);
      console.log("Master3 width : " + masterOrignalPageWidth);
      console.log("Master3 flage : " + flag);
      if (masterOrignalPageWidth == "") {
        setMasterOrignalPageWidth(pageInfoWidth);
        setMasterOrignalPageHeight(pageInfoHeight);
      } else if (flag != 1) {
        pageInfoHeight = masterOrignalPageHeight;
        pageInfoWidth = masterOrignalPageWidth;
      }
      let calsPercentageFromResolution =
        imageResolution == 300 ? 0.375 : imageResolution == 200 ? 0.563 : 0.75;

      let flagHightAdjustment = mainPageInfo.clientWidth < 568 ? true : false;

      let calsPercentage =
        mainPageInfo.clientWidth - pageInfoWidth < 0
          ? mainPageInfo.clientWidth / pageInfoWidth
          : 1;
      setOrignalPageWidth(
        (calsPercentageFromResolution == 1 || flagHightAdjustment == true
          ? calsPercentage
          : calsPercentageFromResolution) * pageInfoWidth
      );
      setOrignalPageHeight(
        (calsPercentageFromResolution == 1 || flagHightAdjustment == true
          ? calsPercentage
          : calsPercentageFromResolution) * pageInfoHeight
      );
      console.log("page: pageInfo.width:" + pageInfoWidth);
      console.log("page: pageInfo.height:" + pageInfoHeight);
      setpageWidthValue(
        (calsPercentageFromResolution == 1 || flagHightAdjustment == true
          ? calsPercentage
          : calsPercentageFromResolution) * pageInfoWidth
      );
      setpageWidthLeftValue(
        (mainPageInfo.clientWidth -
          (calsPercentageFromResolution == 1 || flagHightAdjustment == true
            ? calsPercentage
            : calsPercentageFromResolution) *
          pageInfoWidth) /
        2
      );
      setpageHeightValue(
        (calsPercentageFromResolution == 1 || flagHightAdjustment == true
          ? calsPercentage
          : calsPercentageFromResolution) * pageInfoHeight
      );

      if (pageInfo != null && pageInfo.clientWidth > pageInfo.clientHeight) {
        setZoomClassHeight("rpdf-height" + 2);
        setZoomClassFull("fixed-postion");
        let localOrignalPageHeight =
          (calsPercentageFromResolution == 1 || flagHightAdjustment == true
            ? calsPercentage
            : calsPercentageFromResolution) * pageInfoHeight;
        let localOrignalPageWidth =
          (calsPercentageFromResolution == 1 || flagHightAdjustment == true
            ? calsPercentage
            : calsPercentageFromResolution) * pageInfoWidth;
        let zoomperValue =
          1 +
          (mainPageInfo.clientHeight - 63 - 90 - localOrignalPageHeight) /
          localOrignalPageHeight;
        let text = Math.round(parseFloat(zoomperValue) * 100) + "%";
        let divImgWidth = Math.round(
          parseInt(localOrignalPageWidth) * parseFloat(zoomperValue)
        );
        let divImgHeight = Math.round(
          parseInt(localOrignalPageHeight) * parseFloat(zoomperValue)
        );
        setpageWidthValue(divImgWidth);
        setpageWidthLeftValue((mainPageInfo.clientWidth - divImgWidth) / 2 + 7);
        setpageHeightValue(divImgHeight);
        setZoomValue(2);
        setZoomText(text);
        setShow(false);
      }
    }
  }

  function handlePageOnload() {
    handleUsePageOnload(1);
    //setOpenLoader(false);
  }

  useEffect(() => { }, [totalPages]);

  useEffect(() => { }, [VotedValue]);
  useEffect(() => { }, [userlist]);
  useEffect(() => { }, [zoomText]);
  useEffect(() => { }, [zoomPercentage]);
  useEffect(() => {
    function handleResize() {
      var mainview = document.getElementById("rpdBody");
      if (
        orignalMainPageWidth != mainview.clientWidth &&
        orignalMainPageHeight != mainview.clientHeight - 63
      )
        handleUsePageOnload(0);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  async function getRpddata() {
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null
    ) {
      browserName = getBrowserName();
      console.log(browserName);
      //console.log("testing");

      console.warn("when rpddata/ called " + new Date());
      const url = `${process.env.REACT_APP_API}/docs/rpddata/${documentId}/${openId}`;

      try {
        await fetch(url, {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            let constUserList = "";
            console.warn("when rpddata/ responded " + new Date());
            if (data != null && data != "" && data.authenticated) {
              clearTimerAndInterval();
              window.open(data.redirectUrl, "_self");
            }

            documentName = data.data.fileName;
            rdocsLevel = data.data.levelValue;
            //Voting
            if (data && data.data != null && data.data.isVoting) {
              setisVoting(data.data.isVoting);
            }
            if (data.data.isVoteSharing) {
              setsharevoting(data.data.isVoteSharing);
            }

            if (
              data.data.isVoting &&
              data.data.votingValue != -1 &&
              data.data.votingValue != null
            ) {
              setVotedValue(data.data.votingValue);
              setisVoting(true);
              setisVoted(true);
            }
            //distributionList
            if (
              data &&
              data.data != null &&
              data.data.isDistributionList &&
              data.data.recipients &&
              data.data.recipients.length > 0
            ) {
              setisDistributionList(true);
              //console.log("userlist" + data.data.recipients);
            }

            //side note
            if (data != null && data.data != null) {
              setisPrint(data.data.isCanPrint);

              setSenderEmailAddress(data.data.senderEmailAddress);
              setLoginEmailAddress(data.data.emailAddress);

              setTotalPages(data.data.pages);
              totalPagesCount = data.data.pages;

              setUserList(data.data.recipients);

              if (
                JSON.parse(data.data.sideNote) != null &&
                JSON.parse(data.data.sideNote) != ""
              ) {
                setDocNote(JSON.parse(data.data.sideNote));
                setisSideNote(true);
              }
            }
            //stegabigraphy
            if (
              data &&
              data.data != null &&
              data.data.isSteganography &&
              data.data.emailAddress
            ) {
              let concEmails = "";
              let concEmailsSets = "";
              identifyLeakerEmailLoopCount.map((item) => {
                concEmails =
                  concEmails +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  data.data.emailAddress;
              });

              identifyLeakerLoopCount.map((item) => {
                concEmailsSets =
                  concEmailsSets + "<div>" + concEmails + "</div>";
              });
              setIdentifyLeakerText(concEmailsSets);
              // setstegVal1(data.data.emailAddress);
              // setstegVal2(data.data.emailAddress);
              // setstegVal3(data.data.emailAddress);
              //   setstegVal4(data.data.emailAddress);
              //   setstegVal5(data.data.emailAddress);
              //   setstegVal6(data.data.emailAddress);
              //   setstegVal7(data.data.emailAddress);
              //  setstegVal8(data.data.emailAddress);

              // steg("steg1");
              // setTimeout(() => {
              //   steg("steg2");
              // }, 1000);

              // setTimeout(() => {
              //   steg("steg3");
              // }, 1000);

              // setTimeout(() => {
              //   steg("steg4");
              // }, 1000);
              // setTimeout(() => {
              //   steg("steg5");
              // }, 1000);
              // setTimeout(() => {
              //   steg("steg6");
              // }, 1000);
              // setTimeout(() => {
              //   steg("steg7");
              // }, 1000);
              // setTimeout(() => {
              //   steg("steg8");
              // }, 1000);
            }
            setrecipientId(data.data.recipientId);
            console.log(data.data.recipientId);
            tempRecipientId = data.data.recipientId;

            //allowResponsesTo
            // if (
            //   data &&
            //   data.data != null &&
            //   data.data.allowResponsesTo != null &&
            //   data.data.allowResponsesTo != ""
            // ) {

            // }
            setisAllowResponsesTo(true);

            if (
              data.data.allowResponsesTo != null &&
              data.data.allowResponsesTo != ""
            ) {
              setItems(data.data.allowResponsesTo.split(","));
              setdefaultToAddress(data.data.allowResponsesTo.split(",")[0]);
              setAllowResponsesTo(data.data.allowResponsesTo.split(",")[0]);
            }

            setreplySubject(""); //data.data.subject
            setdefaultSubject(""); //data.data.subject
          });
      } catch (error) {
        console.log(error);
        return () => { };
      }
      getLanguageTranslations();
    }
  }
  async function getLanguageTranslations() {
    const browserlanguage = window.navigator.language;
    const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
    let json;
    try {
      var res = await fetch(url);
      json = await res.json();
      console.log(json);
      //setLanguageTranslations(json.data);
      json.data.forEach((element) => {
        if (element.id === "2AC6EFF9-AF8B-4D36-8ABC-0A24B1C56F56")
          setReader_DocumentID(element.description);
        else if (element.id === "9BA629FE-2BA0-4740-89DC-167FCD3CA4C4")
          setReader_EmailAdress(element.description);
        else if (element.id === "3B344AE3-080C-4DFF-B17F-177BCB8D6A15")
          setReader_VerificationCode(element.description);
        else if (element.id === "8CA84CC8-46EE-4009-8EE0-1A9E11571EC8")
          setReader_VerificationCode_Header(element.description);
        else if (element.id === "F07FC5A9-C71D-4E63-911D-255E1544F3EB")
          setReader_Authorize(element.description);
        else if (element.id === "A4598B68-CC37-4B4D-9502-2A839C2C4865")
          setReader_VerificationCode_Message(element.description);
        else if (element.id === "7E85F861-F0E2-4BEC-92C4-2AEFF225FD6D")
          setReader_ClickHere(element.description);
        else if (element.id === "BF02D851-9481-4215-8EDD-2C4F1D1A14F5")
          setReader_AuthorizeFailure(element.description);
        else if (element.id === "B9272BCA-CFE7-4AA6-A530-30F2CC8377C2")
          setReader_GetVerificationCode(element.description);
        else if (element.id === "ECFD0FAA-B485-4499-9966-3A60FAB1ACE5")
          setReader_VerificationCode_Instruction(element.description);
        else if (element.id === "21E54828-A57B-4935-BBD5-40F08BD6F130")
          setReader_VerificationCode_Remember(element.description);
        else if (element.id === "BF69DF0D-8FF5-4555-AEC6-447F223E3AD6")
          setReader_PleaseGoBack(element.description);
        else if (element.id === "998BBBEF-9B6E-437A-80DC-56621DCED16D")
          setReader_Submit(element.description);
        else if (element.id === "5C20C8C9-C580-43A4-9E18-577A1F4E431C")
          setReader_ActualSize(element.description);
        else if (element.id === "8BCEBAA5-21F8-4D04-89D4-5A76836CB327")
          setReader_FitPage(element.description);
        else if (element.id === "294EBBB5-D0FA-42B8-B3AD-5F549463AAFD")
          setReader_FullWidth(element.description);
        else if (element.id === "BFE1787E-D04C-494C-A9E5-62496FA3FE08")
          setReader_DistributionList(element.description);
        else if (element.id === "AA313936-D9D9-408B-BBDB-6A8CE6CABB08")
          setReader_SideNote(element.description);
        else if (element.id === "7F73F129-096E-4BBA-B731-7A189872F835")
          setReader_ReplyToOwner(element.description);
        else if (element.id === "326A65C1-89D3-4554-ADAD-7B7E9B08E42C")
          setReader_Print(element.description);
        else if (element.id === "2FDC29C8-1A0D-4EED-9385-7F8CDFBB6A0F")
          setReader_Zoom(element.description);
        else if (element.id === "AE91A15B-35AF-480E-9250-8A65A062A596")
          setReader_EnterYourEmailAddress(element.description);
        else if (element.id === "B0C2990F-CDE0-45BE-B7DC-8C9B52338536")
          setReader_Email(element.description);
        else if (element.id === "6AB42951-6546-44B6-9750-C94B8BC3FA95")
          setReader_Passcode(element.description);
        else if (element.id === "442CE6A9-22AF-408A-A2AA-92EE577999A7")
          setReader_OK(element.description);
        else if (element.id === "B6785E69-9416-47A2-BDFA-9537E6A60591")
          setReader_Getpasscode(element.description);
        else if (element.id === "7754F0CA-053D-4203-9261-9A8D4BE56746")
          setReader_GetPasscode(element.description);
        else if (element.id === "818E8449-D5EE-4820-A646-9AC8D1D4F984")
          setReader_EnterYourEmailAddressCode(element.description);
        else if (element.id === "DC458BAF-A9A8-403A-913A-A7C7C417A578")
          setReader_Cancel(element.description);
        else if (element.id === "434DDE98-2BB2-4A7C-82DE-AB6D6DEE9E7B")
          setReader_DocumentExpired(element.description);
        else if (element.id === "BBB2A9AA-0CBB-4175-B827-AC3FAF91B20C")
          setReader_FailedVerifyCodeEmail(element.description);
        else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
          setReader_Continue(element.description);
        else if (element.id === "A43B773D-45DD-4968-809E-AE3271A639B3")
          setReader_GeneralTermsFooter(element.description);
        else if (element.id === "C920E4EB-129F-4EDC-BE19-B1CA133E0A19")
          setReader_GeneralTerms(element.description);
        else if (element.id === "674C0F1F-6EA4-443A-BD38-B47030C2ADA9")
          setReader_Patent(element.description);
        else if (element.id === "6F6B09DC-D705-4F70-A5AD-BA539115C23F")
          setReader_CheckYourEmail(element.description);
        else if (element.id === "1E0B6C7D-24EB-4697-8F00-CB3B3EECC1EE")
          setReader_APasscodeEmailed(element.description);
        else if (element.id === "809D3F1D-D2E6-475D-BEAB-CE7A6795C147")
          setReader_AVerificationCodeEmailed(element.description);
        else if (element.id === "3387D8D0-BDDB-4FA5-BE71-DBADEC20A0D4")
          setReader_TryAgain(element.description);
        else if (element.id === "AD9099E6-C2C1-480E-96F4-DC148642A783")
          setReader_DocumentRestrictedAccess(element.description);
        else if (element.id === "D22EFEBA-D89A-49E8-B544-DF728B2EC62C")
          setReader_ReachedMaximumViews(element.description);
        else if (element.id === "0FCF576E-DB5C-4246-B05F-E88215C69731")
          setReader_DocumentIsNoLongerAvailable(element.description);
        else if (element.id === "697A33A8-5735-4064-9866-E95832CC8303")
          setReader_InactivityYourSessionWillEnd(element.description);
        else if (element.id === "33903FCD-2591-469E-8891-E9B6F0746E3B")
          setReader_Minutes(element.description);
        else if (element.id === "12BCE010-F096-41B5-AE4F-EA98B2310538")
          setReader_Seconds(element.description);
        else if (element.id === "F84C536A-E172-4C14-B827-F06DC17E31D0")
          setReader_SessionTimedOut(element.description);
        else if (element.id === "1A9D7565-3DEB-4AF1-A60E-F5B08F62C834")
          setReader_YouHaveBeenInactive(element.description);
        else if (element.id === "33d700da-e8fe-4c9d-b271-21d1face2264")
          setReader_RPDYouHaveBeenInactive(element.description);
        else if (element.id === "817258A6-5338-4508-8733-F6437E942CBD")
          setReader_ContinueReadingDocument(element.description);
        else if (element.id === "FFDF3914-4CC6-4C02-A6D2-FC05F2A375F7")
          setReader_PrintingDocumentIsNotPermitted(element.description);
        else if (element.id === "27FF1441-6850-4601-B2DD-075D3AD01AEE")
          setReader_ConfirmYourVote(element.description);
        else if (element.id === "771A386D-B1F0-485C-B448-1D340209D580")
          setReader_OnlyVoteOnce(element.description);
        else if (element.id === "3341B4F5-4B0F-4BB1-A04F-46CFB98C803F")
          setReader_Like(element.description);
        else if (element.id === "CA3DB143-B23C-4351-B635-5E636C37664C")
          setReader_Dislike(element.description);
        else if (element.id === "E06FF01E-F57C-4337-94E5-986B31AB1D41")
          setReader_Voting(element.description);
        else if (element.id === "E9D32EC4-BFC1-49E0-9A11-5657B5AD4987")
          setReader_ProtectedDocumentAccess(element.description);
        else if (element.id === "007CF6B5-9AED-4956-A5E8-2D27F40795F9")
          setReader_ProtectedDocument(element.description);
        else if (element.id === "EEC944B7-CF89-4073-AAB2-38C5CD4C388C")
          setReader_AllRightsReserved(element.description);
        else if (element.id === "53708ED8-B8C6-4246-AB81-76F49FAC7E1C")
          setReader_Terms(element.description);
        else if (element.id === "AB232AED-8FB4-4E72-A550-DC57477EA1BE")
          setReader_DocumentServerUnavailable(element.description);
        else if (element.id === "977B4401-07E3-4848-870E-D7519A89BE0A")
          setReader_InternetConnectionRequired(element.description);
        else if (element.id === "A46D6AA3-7989-468F-85FE-AA9CA637A63A")
          setReader_EnteredEmailIsNotReadersList(element.description);
        else if (element.id === "D4FE0525-1829-48FE-87F7-D248053B5BF8")
          setReader_FailedSendVerifyCode(element.description);
        else if (element.id === "A399DFA9-C65E-40CC-A51B-7D3825270DB6")
          setReader_UserVerificationFailure(element.description);
        else if (element.id === "01464BDE-1F06-4CE4-B382-0D12FD415573")
          setReader_DocName(element.description);
        else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
          setReader_ID(element.description);
        else if (element.id === "B1B1DD59-8DE0-4F34-914D-3BC9BF7C549A")
          setReader_EnterEmailGetPasscode(element.description);
        else if (element.id === "4D24E110-C95C-44DC-8DE0-586EEFD43901")
          setReader_PleaseEnterSubject(element.description);
        else if (element.id === "55F7F90F-5079-44D9-80C6-75E5CA0F3D8E")
          setReader_EmailSuccessfullySent(element.description);
        else if (element.id === "2B5CD1B8-E2C1-40FE-8657-81297F664F97")
          setReader_DigitalRightsManagement(element.description);
        else if (element.id === "384088DF-3A77-4AE7-9B85-2349394EFC30")
          setReader_ProtectedDocumentViewer(element.description);
        else if (element.id === "BCE385E2-E768-479E-8A28-7D90B153347E")
          setReader_ViewDistributionList(element.description);
        else if (element.id === "549961D1-C11B-4EF6-BFFC-8DC5BB995463")
          setReader_UsersList(element.description);
        else if (element.id === "F4CE40B3-2391-4A0B-BBB9-930710845A68")
          setReader_ViewSideNote(element.description);
        else if (element.id === "56B9CC7C-747E-420E-A5ED-B3F1C0A73D3B")
          setReader_NoteFrom(element.description);
        else if (element.id === "F8109066-3DEF-4FD3-A4A3-C6170D9D1CF8")
          setReader_ReplyToDocument(element.description);
        else if (element.id === "3C7C0F84-FC5E-416A-9E6B-110606DBE2DF")
          setReader_ClickToPrint(element.description);
        else if (element.id === "BA8DC442-BB68-4D4F-978F-64DE3B71D467")
          setReader_Send(element.description);
        else if (element.id === "EF11C8AF-E646-493F-9016-583861FF6008")
          setReader_Message(element.description);
        else if (element.id === "C1988359-42CB-41A2-8336-C7767AAE9406")
          setReader_Subject(element.description);
        else if (element.id === "4E086CF8-AAD1-4717-8CA4-E3C22EFC6256")
          setReader_ToAddress(element.description);
        else if (element.id === "39265EFF-9C1B-49D3-98BA-7110FA4AEB62")
          setReader_YouWillLoggedIn(element.description);
        else if (element.id === "CCC0FADA-9CD5-4BFD-BAEB-7EE9B9677DF1")
          setReader_ClickToVote(element.description);
        else if (element.id === "45dc6e20-a9a2-4b1e-90b4-27dcae4809c3")
          setReader_DocumentHasNoAccess(element.description);
        else if (element.id === "0F8665A9-F7F3-4D07-8F64-E0F0576079D0")
          setReader_AccessDocument(element.description);
        else if (element.id === "F99602CF-AF87-4DE1-A20B-E82A064F1B51")
          setReader_SessionExpiredAccessDocument(element.description);
        else if (element.id === "8B569962-71C7-48A6-BDD0-43C37B489D91")
          setReader_PleaseTryAgain(element.description);
        else if (element.id === "5CA9B16D-46A7-43E9-9B3D-9076CB4C18B9")
          setReader_CheckYourConnection(element.description);
        else if (element.id === "C24DB5B6-951E-4E47-AEE1-A401FE85A7C3")
          setReader_LegalNotices(element.description);
        else if (element.id === "511A78A4-02CB-4EF0-A05C-3A8FC1EB92A7")
          setReader_ClickServiceLevelTerms(element.description);
        else if (element.id === "0C6DC977-FFCA-45BD-83DA-CD11AC5B7E6B")
          setReader_OtherService(element.description);
        else if (element.id === "7A4227D5-6EF9-4BB2-BB83-4D63FA9524D2")
          setReader_NoUnitbalanceMessage(element.description);
        else if (element.id === "4ddea558-4a3f-43b8-bdb2-d69df1c2162c")
          setReader_BotInfoMessage(element.description);
        else if (element.id === "47dd41f8-d61f-42ad-a0be-38195c694d01")
          setReader_robot(element.description);
        else if (element.id === "4d9606ee-3ddd-46cb-8444-b656e4b217ad")
          setReader_Botverified(element.description);
        else if (element.id === "d46741cd-dc5d-4ba5-984f-2c4dec6989dd")
          setReader_BotVerifiedMessage(element.description);
        else if (element.id === "6B574532-AAD2-4356-86FC-5C2F27E90FFE")
          setReader_InternetConnectProblem(element.description);
        else if (element.id === "555ADB9D-8867-4455-8BB7-85EA9BA0C2BB")
          setReader_ConnectivityReauthenticate(element.description);
        else if (element.id === "CFC1376B-2F1F-4200-A0E8-19412FAB9474")
          setAPI_SubjectMsg(element.description);
        else if (element.id === "3B15B3BF-8614-4F18-A536-945EBD9F3FDB")
          setReader_EmailBodyMsg(element.description);
        else if (element.id === "76c385b7-0cb7-4b34-80a1-8bc30add9fe1")
          setReader_viewTime(element.description);
        else if (element.id === "73243072-681e-41af-b4dc-bfe19afb7631")
          setReader_AuthenticatingPleaseWait(element.description);
        else if (element.id === "B4CC3606-EB28-4160-9D8B-CBB2CE6A0460")
          setReader_minutesSmall(element.description);
        else if (element.id === "6CF1E413-78A3-408D-A6AE-BE56762F8417")
          setReader_secondsSmall(element.description);
        else if (element.id === "752D062E-8E70-4E26-B3F5-59ADC21BAAB0")
          setReader_YouWillbeLoggedOutIn(element.description);
        else if (element.id === "29d0e16e-63e2-4e15-999b-1d6843f5cc50")
          setReader_RequestingPassCodePleaseWait(element.description);
        else if (element.id === "30fcbad0-5163-4163-846a-6be2110781ce")
          setReader_ReplyToDocumentPleaseWait(element.description);
        else if (element.id === "9fee0ab5-c17f-4fc2-a5c2-b943069f442d")
          setReader_PrintDocumentPleaseWait(element.description);
        else if (element.id === "088dcf20-c3a7-489d-83c1-9a6b8030dc21")
          setReader_NavigatingBnPagesPleaseWait(element.description);
        else if (element.id === "751eda8a-d7d1-4cb6-a70d-c0a24fcb2eaf")
          setReader_AllowedPagesOnly(element.description);
        else if (element.id === "99430065-7d6c-451b-ade7-bdccc645212d")
          setReader_YouDontHaveAccess(element.description);
        else if (element.id === "bc66c66e-43cf-42dc-bbf7-03166f4c6722")
          setReader_YouDontHaveAccessToRequested(element.description);
        else if (element.id === "c440a0bc-3d9e-4cac-95a4-cddf1eec9a3a")
          setRPostReader_viewTime(element.description);
        else if (element.id === "c77447de-ae4a-42a9-9f82-f8bf21ed8d57")
          setReader_LoadingPleaseWait(element.description);
        else if (element.id === "dd95e45e-0fbd-4f34-aecf-021afcf57c3a")
          setReader_SendingYourReply(element.description);



      });
    } catch (error) {
      console.log("error in languagetranslations: " + error);
      return () => { };
    }
  }

  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }
  async function check(TimeinSeconds, currPageNum, IsAutoInvoke, stopFlag) {
    console.log(" TimeinSeconds: " + TimeinSeconds + " currPageNum: " + currPageNum + " IsAutoInvoke: " + IsAutoInvoke + " stopFlag: " + stopFlag);
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null &&
      window.location.href.toLowerCase().indexOf(readerPageUrl) > -1
    ) {
      if (waitcount == 0 && noInternetval == 0) {
        if ((IsAutoInvoke === true && TimeinSeconds >= 60) || !IsAutoInvoke) {
          if (timeTrackRef.current) {
            clearInterval(timeTrackRef.current);
            timeTrackRef.current = null;
          }
          if (!stopFlag) {
            timeTrackRef.current = setInterval(function () {
              check(60, "", true);
            }, 60000);
          }
          tCount = 0;

          console.log(pageNumber);
          start += 1;
          let count = start;
          const url = `${process.env.REACT_APP_API}/docs/track`;
          handleClose = 0;
          var rpdreadInfo = {
            documentId: documentId,
            id: openId,
            ActivityTime: TimeinSeconds == undefined ? 60 : TimeinSeconds,
            client: browserName,
            RecipientId: tempRecipientId,
            CurrentPage: !currPageNum ? pageNumber : currPageNum,
          };

          await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(rpdreadInfo),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.authenticated) {
                clearTimerAndInterval();
                if (
                  response.message != null &&
                  response.message === "declined"
                ) {
                  localStorage.setItem("DeclinedVar_" + documentId, "true");
                } else {
                  localStorage.setItem("DeclinedVar_" + documentId, "false");
                }
                window.open(response.redirectUrl, "_self");
              }
              console.log(response);
            })
            .catch((error) => {
              console.log("Document read error");
            });
          start = 0;
          waitcount = 0;
          console.log(count);
        }
      }
    }
  }
  function startTimer() {
    logout = true;
    timerCount = 0;
    localStorage.setItem("timerCountRPD" + randomNumRpost, 0);
    //max_count = 900; //1800
    startCount();
  }

  function startCount() {
    timer = setTimeout(function () {
      startCount();
    }, 1000);

    logout = true;
    var remaining_time = 0;

    if (noInternetval == 0) {
      localStorage.setItem(
        "timerCountRPD" + randomNumRpost,
        parseInt(localStorage.getItem("timerCountRPD" + randomNumRpost)) + 1
      );
      timerCount = timerCount + 1;

      //var remaining_time = max_count - timerCount;
      remaining_time =
        max_count -
        parseInt(localStorage.getItem("timerCountRPD" + randomNumRpost));
      NoInternetRemainingVal = remaining_time;
    } else {
      remaining_time = NoInternetRemainingVal;
    }

    if (remaining_time <= 0 && logout && !isSessionEndedForUser) {
      //waitcount = 1;
      SessionpopuupDisable = 0;
      isSessionEndedForUser = true;
      setOpen(false);
      resetTimer();
      localStorage.removeItem(
        localStorage.getItem("timerCountRPD" + randomNumRpost)
      );
      check(tCount);
      clearTimerAndInterval();
      localStorage.setItem(`FileName${documentId}`, documentName);
      history(
        `/Default/SessionExpireMessage/${documentId}/${rdocsLevel}/${documentName}`
      );
      return;
    } else if (remaining_time < logoutWarnTime) {
      SessionpopuupDisable = 1;
      var tempTime = moment.duration(remaining_time, "s");

      setMinutesVal(tempTime.get("minutes"));
      setSecondsVal(tempTime.get("seconds"));
      setOpen(true);
      stopTimmer();
      waitcount = 1;
    } else {
      setOpen(false);
    }
  }
  function resetTimer() {
    if (SessionpopuupDisable == 1) {
      setOpen(true);
    } else {
      setOpen(false);

      logout = false;
      waitcount = 0;
      isSessionEndedForUser = false;
      timerCount = 0;
      localStorage.setItem("timerCountRPD" + randomNumRpost, 0);
      settimerValue("5 minute(s) & 00 second(s)");
    }
  }

  function steg(steg) {
    let id = null;
    const elem = document.getElementById(steg);

    let pos = 1;
    id = setInterval(frame, 200);
    var rect = document.getElementById("page").getBoundingClientRect();
    console.log("page boundingclient :" + rect);
    console.log(
      "top :" + Math.floor(Math.random() * rect.height) + rect.top + 50 + "px"
    );
    console.log(
      "left :" +
      Math.floor(Math.random() * rect.width) +
      (rect.left - 40) +
      "px"
    );
    elem.style.top =
      Math.floor(Math.random() * rect.height) + rect.top + 50 + "px";
    elem.style.left =
      Math.floor(Math.random() * rect.width) + (rect.left - 40) + "px";
    function frame() {
      var eTop = parseInt(elem.style.top, 10);
      var eLeft = parseInt(elem.style.left, 10);
      if (document.getElementById("page") != null) {
        var rect = document.getElementById("page").getBoundingClientRect();
        console.log("frame page boundingclient :" + rect);
        if (eTop > rect.bottom - 100 || eLeft > rect.left + rect.width - 100) {
          elem.style.top =
            Math.floor(Math.random() * rect.height) + rect.top + 50 + "px";
          elem.style.left = rect.left - 40 + "px";
          console.log(
            "frame page boundingclient top :" +
            Math.floor(Math.random() * rect.height) +
            rect.top +
            50 +
            "px"
          );
          console.log(
            "frame page boundingclient left :" + rect.left - 40 + "px"
          );
        } else {
          elem.style.top = eTop + pos + "px";
          console.log(
            "frame page boundingclient top else :" + eTop + pos + "px"
          );
          console.log(
            "frame page boundingclient left else :" + eLeft + pos + "px"
          );
          elem.style.left = eLeft + pos + "px";
        }
      }
    }
  }
  function clearTimerAndInterval() {
    clearTimeout(timer);
    if (timeTrackRef.current) {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
  }
  const ValidatePageViewAccess = async (cPage, flag) => {
    resetTimer();
    console.warn("when ValidatePageViewAccess/ called " + new Date());
    const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}/${flag}`;
    await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        console.warn("when ValidatePageViewAccess/ responded " + new Date());
        console.log(response);

        if (
          response.authenticated &&
          response.sucess == "true" &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          clearTimerAndInterval();
          window.open(response.redirectUrl, "_self");
        } else if (
          response.authenticated &&
          response.sucess == "false" &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          clearTimerAndInterval();
          if (response.message != null && response.message == "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          }

          window.open(response.redirectUrl, "_self");
        } else if (
          response.authenticated &&
          response.sucess == "true" &&
          response.redirectUrl == null
        ) {
          return response;
        } else {
          setOpenVoting(true);
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
  };
  const handleKeyDownPageNumChange = (event) => {
    if (event.key === 'Enter') {
      totalPagesRef.current?.blur();
    }
  };
  const handleBlurPageNumChangeWrapper = async () => {
    if (localPageLevelRestriction) {
      if (handleValidatePageRestriction(currentTempPage)) {
        handleBlurPageNumChange();
      }
      else
      {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
        setTempPage(currentGlobalpage);
        totalPagesRef.current?.blur();
      }
    }
    else
      handleBlurPageNumChange();
  }
  const handleBlurPageNumChange = async () => {
    if (currentTempPage === "") {
      setTempPage(currentGlobalpage);
      totalPagesRef.current?.blur();
      return; // Early return if the page is empty
    }
    if (currentTempPage != "" && currentGlobalpage != parseInt(currentTempPage)) {
      let page = currentTempPage;
      setOpenLoader(true);
      setDisablePageNavigationButtons(true);
      resetTimer();
      if (page === "" || page === null) {
        setTempPage("");
        setOpenLoader(false);
        return;
      }
      page = parseInt(page);
      if (!isNaN(page) && page <= totalPages && page >= 1) {
        let pageIndex = page - 1;
        pageNumber = pageIndex + 1;
        setLoadingmessage(0);
        if (checkImgDataIsExisted(pageIndex)) {
          ValidatePageViewAccess(pageIndex, true);
          setImgDataFromExisted(pageIndex);
          setPage(page);
          currentGlobalpage = page;
          setTempPage(page);
        } else {
          ValidatePageViewAccess(pageIndex, false);
          handlePageNavigation(pageIndex, 1, false);
        }
        loadNextPreviousPages(pageIndex);
        check(tCount, currentpage);
      } else {
        setTempPage(pageNumber);
        setOpenLoader(false);
        setDisablePageNavigationButtons(false);
      }
    }
    totalPagesRef.current?.blur();
  };
  const handlePageNumChange = (page) => {
    console.log("handle blur");
    setTempPage(page);
  };
  const handleValidatePageLevelRestriction = (incrementDecriment, curPageNumber) => {
    if (incrementDecriment == "decrement") {
      curPageNumber = curPageNumber - 1;
      for (let index = curPageNumber; index > 0; index--) {
        let pageRestricted = false;
        documentLevelRestrictionDetails.forEach(element => {
          if (element.pages.includes(index)) {
            pageRestricted = true;
            return;
          }
        });
        if (!pageRestricted) {
          return index;
        }
      }
      return curPageNumber + 1;
    }
    else {
      curPageNumber = curPageNumber + 1;
      for (let index = curPageNumber; index <= totalPages; index++) {
        let pageRestricted = false;
        documentLevelRestrictionDetails.forEach(element => {
          if (element.pages.includes(index)) {
            pageRestricted = true;
            return;
          }
        });
        if (!pageRestricted) {
          return index;
        }
      }
      return curPageNumber - 1;
    }
  }
  const handleValidatePageRestriction = (curPageNumber) => {
    let validateFlag = true;
    documentLevelRestrictionDetails.forEach(element => {
      if (element.pages.includes(parseInt(curPageNumber))) {
        validateFlag = false;
        return false;
      }
    });
    return validateFlag;
  }
  const handleNextChangeWrapper = async (event) => {
    if(currentpage >= totalPages)
    {
      return;
    }
    let revicedPage = currentpage;
    if (localPageLevelRestriction) {
      revicedPage = handleValidatePageLevelRestriction("increment", currentpage);
      if(revicedPage == currentpage)
      {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
        return;
      }
      else {
        revicedPage = revicedPage - 1;
    }
    }
    handleNextChange(revicedPage);
  }
  const handleNextChange = async (revicedPage) => {
    if (handleNextChangeTimeout != undefined)
      clearTimeout(handleNextChangeTimeout);
    handleNextChangeTimeout = setTimeout(() => {
      setDisablePageNavigationButtons(true);
      setOpenLoader(true);
      resetTimer();
      if (totalPages > revicedPage) {
        let pageIndex = revicedPage;
        pageNumber = pageIndex + 1;
        setLoadingmessage(0);
        if (checkImgDataIsExisted(pageIndex)) {
          ValidatePageViewAccess(pageIndex, true);
          setImgDataFromExisted(pageIndex);
          setPage(parseInt(pageNumber));
          currentGlobalpage = parseInt(pageNumber);
          setTempPage(parseInt(pageNumber));
        } else {
          ValidatePageViewAccess(pageIndex, false);
          handlePageNavigation(pageIndex, 2, false);
        }
        loadNextPreviousPages(pageIndex);
        check(tCount, revicedPage);
      } else {
        setOpenLoader(false);
        setDisablePageNavigationButtons(false);
      }
    }, 500);
  };
  var handlePreviousChangeTimeout;
  var handleNextChangeTimeout;
  const handlePreviousChangeWrapper = async (event) => {
    if(currentpage <= 1)
    {
      return ;
    }
    let revicedPage = currentpage;
    if (localPageLevelRestriction) {
      revicedPage = handleValidatePageLevelRestriction("decrement", currentpage);
      if(revicedPage == currentpage)
      {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
        return;
      }
      else{
        revicedPage = revicedPage + 1;
      }
    }
    handlePreviousChange(revicedPage);
  }
  const handlePreviousChange = async (revicedPage) => {
    if (handlePreviousChangeTimeout != undefined)
      clearTimeout(handlePreviousChangeTimeout);
    handlePreviousChangeTimeout = setTimeout(() => {
      setDisablePageNavigationButtons(true);
      setOpenLoader(true);
      resetTimer();
      if (revicedPage > 1) {
        let pageIndex = revicedPage - 2;
        pageNumber = pageIndex + 1;
        setLoadingmessage(0);
        if (checkImgDataIsExisted(pageIndex)) {
          ValidatePageViewAccess(pageIndex, true);
          setImgDataFromExisted(pageIndex);
          setPage(parseInt(pageNumber));
          currentGlobalpage = parseInt(pageNumber);
          setTempPage(parseInt(pageNumber));
        } else {
          ValidatePageViewAccess(pageIndex, false);
          handlePageNavigation(pageIndex, 3, false);
        }
        loadNextPreviousPages(pageIndex);
        check(tCount, revicedPage);
      } else {
        setOpenLoader(false);
        setDisablePageNavigationButtons(false);
      }
    }, 500);
  };
  const handleNextMaxWrap = () => {
    if(currentpage >= totalPages)
    {
      return;
    }
    if (localPageLevelRestriction) {
      if (handleValidatePageRestriction(totalPages)) {
        handleNextMax();
      }
      else
      {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
      }
    }
    else
      handleNextMax();
  }
  const handleNextMax = async () => {
    setDisablePageNavigationButtons(true);
    setOpenLoader(true);
    if (currentpage != totalPages) {
      resetTimer();
      let pageIndex = totalPages - 1;
      pageNumber = totalPages;
      setLoadingmessage(0);
      if (checkImgDataIsExisted(pageIndex)) {
        ValidatePageViewAccess(pageIndex, true);
        setImgDataFromExisted(pageIndex);
        setPage(parseInt(pageNumber));
        currentGlobalpage = parseInt(pageNumber);
        setTempPage(parseInt(pageNumber));
      } else {
        ValidatePageViewAccess(pageIndex, false);
        handlePageNavigation(pageIndex, 4, false);
      }
      loadNextPreviousPages(pageIndex);
      check(tCount, currentpage);
    } else {
      setOpenLoader(false);
      setDisablePageNavigationButtons(false);
    }
  };
  const handlePreviousMinWrap = () => {
    if(currentpage <= 1)
    {
      return;
    }
    if (localPageLevelRestriction) {
      if (handleValidatePageRestriction(1)) {
        handlePreviousMin();
      }
      else
      {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
      }
    }
    else
      handlePreviousMin();
  }
  const handlePreviousMin = async () => {
    setDisablePageNavigationButtons(true);
    setOpenLoader(true);
    if (currentpage != 1) {
      let pageIndex = 0;
      pageNumber = pageIndex + 1;
      setLoadingmessage(0);
      if (checkImgDataIsExisted(pageNumber)) {
        ValidatePageViewAccess(pageIndex, true);
        setImgDataFromExisted(pageIndex);
        setPage(1);
        currentGlobalpage = 1;
        setTempPage(1);
      } else {
        ValidatePageViewAccess(pageIndex, false);
        handlePageNavigation(pageIndex, 5, false);
      }
      loadNextPreviousPages(pageIndex);
      check(tCount, currentpage);
    } else {
      setOpenLoader(false);
      setDisablePageNavigationButtons(false);
    }
  };

  const handlePageNavigation = async (pageIndex, requestedFrom, flag) => {
    if (requestedFrom == 1) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag
      );
      pageNumber = pageIndex + 1;
      setPage(parseInt(pageNumber));
      currentGlobalpage = parseInt(pageNumber);
      setTempPage(parseInt(pageNumber));
    } else if (requestedFrom == 2) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag
      );
      pageNumber = pageIndex + 1;
      setPage(pageNumber);
      currentGlobalpage = parseInt(pageNumber);
      setTempPage(parseInt(pageNumber));
    } else if (requestedFrom == 3) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag
      );
      pageNumber = pageIndex + 1;
      setPage(pageNumber);
      currentGlobalpage = parseInt(pageNumber);
      setTempPage(parseInt(pageNumber));
    } else if (requestedFrom == 4) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag
      );
      pageNumber = pageIndex + 1;
      setPage(pageNumber);
      currentGlobalpage = parseInt(pageNumber);
      setTempPage(pageNumber);
    } else if (requestedFrom == 5) {
      resetTimer();
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag
      );
      pageNumber = 1;
      setPage(1);
      currentGlobalpage = 1;
      setTempPage(1);
    }
  };

  const handleImageData = async (url, flag) => {
    console.warn("when image/ called " + new Date());
    await fetch(url + "/" + flag + "/true", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        }
        if (response.status == 404) {
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        console.warn("when image/ responded " + new Date());
        if (
          response.authenticated &&
          response.sucess == "true" &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          clearTimerAndInterval();
          window.open(response.redirectUrl, "_self");
        } else if (
          response.authenticated &&
          response.sucess == "false" &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          clearTimerAndInterval();
          window.open(response.redirectUrl, "_self");
        } else if (response.sucess == "true") {
          if (response.flag != true) {
            //if((currentpage-1)==response.pageNum)
            setImgURLData(response.image);
            setPageLevelRestriction(response.pageLevelRestriction);
            if (response.pageNum == 0) {
              setDocumentLevelRestriction(response.documentRestriction);
              setDocumentLevelRestrictionDetails(response.documentPageLevelRestrictionDetails);
            }
            //locImgURLDataArray = [...imgURLDataArray];
            locImgURLDataArray.push({
              image: response.image,
              pageNum: response.pageNum,
              pageLevelRestriction: response.pageLevelRestriction,
            });
            //setImgURLDataArray(locImgURLDataArray);
          } else {
            locImgURLDataArray.push({
              image: response.image,
              pageNum: response.pageNum,
              pageLevelRestriction: response.pageLevelRestriction,
            });
          }
          console.log(locImgURLDataArray);
          if (response.flag != true) {
            setOpenLoader(false);
            setDisablePageNavigationButtons(false);
          }
        } else {
          setPageviewModelOpen(true);
          setOpenLoader(false);
          setDisablePageNavigationButtons(false);
        }
      })
      .catch((error) => {
        console.log("Document read error");
        setOpenLoader(false);
        setDisablePageNavigationButtons(false);
      });
  };

  const checkImgDataIsExisted = (cPage) => {
    var verifyFlag = false;
    if (imgURLDataArray.length == 0) {
      return false;
    }
    imgURLDataArray.forEach((element) => {
      if (parseInt(element.pageNum) == cPage && verifyFlag != true) {
        verifyFlag = true;
      }
    });
    if (verifyFlag) return true;
    else return false;
  };
  const setImgDataFromExisted = (cPage) => {
    imgURLDataArray.forEach((element) => {
      if (element.pageNum == cPage) {
        setImgURLData(element.image);
        setPageLevelRestriction(element.pageLevelRestriction);
      }
    });
    setOpenLoader(false);
    setDisablePageNavigationButtons(false);
  };
  const loadNextPreviousPages = (cPage) => {
    setTimeout(() => {
      var imgArrayListToPull = [];
      if (totalPagesCount == 1 && totalPages > 0) {
        totalPagesCount = totalPages;
      }
      if (totalPagesCount <= 5) {
        if (totalPagesCount == 1) imgArrayListToPull = [0];
        else if (totalPagesCount == 2) imgArrayListToPull = [0, 1];
        else if (totalPagesCount == 3) imgArrayListToPull = [0, 1, 2];
        else if (totalPagesCount == 4) imgArrayListToPull = [0, 1, 2, 3];
        else if (totalPagesCount == 5) imgArrayListToPull = [0, 1, 2, 3, 4];
      } else if (cPage == 0 && totalPagesCount > 5) {
        imgArrayListToPull = [1, 2, 3, 4];
      } else if (cPage == 1 && totalPagesCount > 5) {
        imgArrayListToPull = [0, 2, 3, 4];
      } else if (cPage == totalPagesCount - 1 && totalPagesCount > 5) {
        imgArrayListToPull = [
          totalPagesCount - 5,
          totalPagesCount - 4,
          totalPagesCount - 3,
          totalPagesCount - 2,
        ];
      } else if (cPage - 1 == totalPagesCount - 1 && totalPagesCount > 5) {
        imgArrayListToPull = [
          totalPagesCount - 5,
          totalPagesCount - 4,
          totalPagesCount - 3,
          totalPagesCount - 1,
        ];
      } else {
        imgArrayListToPull = generateNumbers(cPage);
      }
      locImgURLDataArray = [...imgURLDataArray];
      imgArrayListToPull.forEach((element) => {
        if (!checkImgDataIsExisted(element)) {
          handleImageData(
            `${process.env.REACT_APP_API}/images/${documentId}/${element}/${openId}`,
            true
          );
        }
      });
      setImgURLDataArray(locImgURLDataArray);
    }, 1000);
  };
  const generateNumbers = (num) => {
    let numbers = [];
    for (let i = num - 2; i <= num + 2; i++) {
      if (i != num) numbers.push(i);
    }
    return numbers;
  };
  const handleToClose = () => {
    SessionpopuupDisable = 0;
    setOpen(false);
    timerCount = 0;
    resetTimer();
    startTimmer();
    handleClose = 0;
    waitcount = 0;
  };
  const stopTimmer = () => {
    if (!stopIndicator) {
      stopIndicator = true;
      if (timeTrackBackRef.current) {
        clearInterval(timeTrackBackRef.current);
        timeTrackBackRef.current = null;
      }
      console.log("stop :" + timeTrackBackRef.current);
      if (timeTrackRef.current) {
        clearInterval(timeTrackRef.current);
        timeTrackRef.current = null;
      }
      console.log("stop :" + timeTrackRef.current);
      check(tCount, currentGlobalpage, false, true);
    }
  }
  const startTimmer = () => {
    stopIndicator = false;
    if (timeTrackBackRef.current) {
      clearInterval(timeTrackBackRef.current);
      timeTrackBackRef.current = null;
    }
    timeTrackBackRef.current = setInterval(TimeCalulation, 1000);
    console.log("start: " + timeTrackBackRef.current);
    if (timeTrackRef.current) {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
    timeTrackRef.current = setInterval(() => {
      check(60, "", true);
    }, 60000);
    console.log("start: " + timeTrackRef.current);
  }
  const recordVote = (vote) => {
    lastVote = vote;
    if (vote == 1) setlastVoting(true);
    else setlastVoting(false);

    setOpenVoting(true);
  };
  const handleToLike = async (e) => {
    resetTimer();
    console.log("handleToLike" + recipientId);
    let url = `${process.env.REACT_APP_API + "/docs/vote"}`;

    let data = {
      RecpientId: recipientId,
      DocumentId: documentId,
      vote: 1,
    };
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setVotedValue(1);
          setUserList(
            userlist.map((item, idex) => {
              if (item.email.toLowerCase() === loginEmailAddress.toLowerCase()) return { ...item, vote: 1 };
              else return { ...item };
            })
          );
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          if (response.message != null && response.message == "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          }
          window.open(response.redirectUrl, "_self");
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
    // var response = await APIRequest.POST(data, url);
    // console.log("res"+response);
  };
  const handleToUnLike = async (e) => {
    resetTimer();
    console.log(recipientId);
    let url = `${process.env.REACT_APP_API + "/docs/vote"}`;
    let data = {
      RecpientId: recipientId,
      DocumentId: documentId,
      vote: 0,
    };
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setVotedValue(0);
          setUserList(
            userlist.map((item, idex) => {
              if (item.email.toLowerCase() === loginEmailAddress.toLowerCase()) return { ...item, vote: 0 };
              else return { ...item };
            })
          );
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          if (response.message != null && response.message == "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          }

          window.open(response.redirectUrl, "_self");
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
    // var response = await APIRequest.POST(data, url);
    // console.log("res" + response);
  };

  const votingdialogClose = () => {
    lastVote = -1;
    setOpenVoting(false);
  };
  const Validatevoting = async () => {
    const url = `${process.env.REACT_APP_API}/docs/vote`;

    var rpdVoting = {
      DocumentId: documentId,
      RecpientId: recipientId,
      vote: lastVote,
    };

    await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdVoting),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.status == "200") {
          setisVoting(true);
          setisVoted(true);
          setVotedValue(lastVote);
          lastVote = -1;
          setOpenVoting(false);
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          window.open(response.redirectUrl, "_self");
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
  };

  const handleMobileZoomDropdown = (e, text, zoomPercentValue) => {
    resetTimer();
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
    //setZoomClass(" r-transform" + e.target.value);
    setZoomClassHeight("rpdf-height" + e.target.value);
    console.log("Dropdown Zoom", e.target.value);

    //   if (e.target.value == 3 || e.target.value == 8){
    //     //setZoomClassFull("col-lg-12")
    //   }
    //  else if ( e.target.value == 7){
    //     //setZoomClassFull("col-lg-10")
    //   }
    //   else{
    //     setZoomClassFull("")
    //   }
    //  if(parseInt(text) == 50){
    //   setZoomClassHeight(" ")
    //   }
    //   else{
    //     setZoomClassHeight("min-vh-95")
    //   }
    if (e.target.value == 2) {
      setZoomClassFull("fixed-postion");
    } else if (e.target.value == 7) {
      setZoomClassFull("");
      setZoomClass("rm-transform7");
    } else if (e.target.value == 8) {
      setZoomClassFull("");
      setZoomClass("rm-transform8");
    } else {
      setZoomClassFull("");
      setZoomClass("");
    }
    let zoomperValue = "1";
    if (zoomPercentValue == "0.5") {
      zoomperValue = "0.5";
    } else if (zoomPercentValue == "0.75") {
      zoomperValue = "0.75";
    } else if (zoomPercentValue == "1") {
      zoomperValue = "1";
    } else if (zoomPercentValue == "1.25") {
      zoomperValue = "1.25";
    } else if (zoomPercentValue == "1.5") {
      zoomperValue = "1.5";
    } else if (zoomPercentValue == "FitPage") {
      let percentageOfPageHeight;
      percentageOfPageHeight =
        1 + (orignalMainPageHeight - orignalPageHeight) / orignalPageHeight;
      zoomperValue = percentageOfPageHeight;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    } else if (zoomPercentValue == "FullWidth") {
      let percentageOfPageWidth;
      percentageOfPageWidth =
        0.99 + (orignalMainPageWidth - orignalPageWidth) / orignalPageWidth;
      zoomperValue = percentageOfPageWidth;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    }
    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );

    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue((orignalMainPageWidth - divImgWidth) / 2);
    setpageHeightValue(divImgHeight);
    setZoomValue(parseInt(e.target.value));
    setZoomText(text);
    setShow(false);
  };

  const handleZoomDropdown = (e, text, zoomPercentValue) => {
    resetTimer();

    //setZoomClass(" r-transform" + e.target.value);
    setZoomClassHeight("rpdf-height" + e.target.value);
    console.log("Dropdown Zoom", e.target.value);

    //   if (e.target.value == 3 || e.target.value == 8){
    //     //setZoomClassFull("col-lg-12")
    //   }
    //  else if ( e.target.value == 7){
    //     //setZoomClassFull("col-lg-10")
    //   }
    //   else{
    //     setZoomClassFull("")
    //   }
    //  if(parseInt(text) == 50){
    //   setZoomClassHeight(" ")
    //   }
    //   else{
    //     setZoomClassHeight("min-vh-95")
    //   }
    if (e.target.value == 2) {
      setZoomClassFull("fixed-postion");
    } else if (e.target.value == 7) {
      setZoomClassFull("");
      setZoomClass("rm-transform7");
    } else if (e.target.value == 8) {
      setZoomClassFull("");
      setZoomClass("rm-transform8");
    } else {
      setZoomClassFull("");
      setZoomClass("");
    }
    let zoomperValue = "1";
    if (zoomPercentValue == "0.5") {
      zoomperValue = "0.5";
    } else if (zoomPercentValue == "0.75") {
      zoomperValue = "0.75";
    } else if (zoomPercentValue == "1") {
      zoomperValue = "1";
    } else if (zoomPercentValue == "1.25") {
      zoomperValue = "1.25";
    } else if (zoomPercentValue == "1.5") {
      zoomperValue = "1.5";
    } else if (zoomPercentValue == "FitPage") {
      let percentageOfPageHeight;
      let hightAdjustment =
        imageResolution == 300 ? 15 : imageResolution == 200 ? 0 : 0;
      percentageOfPageHeight =
        1 +
        (orignalMainPageHeight - orignalPageHeight + hightAdjustment + 12) /
        orignalPageHeight;
      zoomperValue = percentageOfPageHeight;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    } else if (zoomPercentValue == "FullWidth") {
      let percentageOfPageWidth;
      percentageOfPageWidth =
        0.99 + (orignalMainPageWidth - orignalPageWidth) / orignalPageWidth;
      zoomperValue = percentageOfPageWidth;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    }
    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue(
      (orignalMainPageWidth - divImgWidth) / 2 +
      (zoomPercentValue == "FitPage" ? 7 : 0)
    );
    setpageHeightValue(divImgHeight);
    setZoomValue(parseInt(e.target.value));
    setZoomText(text);
    setShow(false);
  };

  const handleZoomOut = (e) => {
    resetTimer();
    if (SessionpopuupDisable == 1) return false;

    var tempZoomValue = zoomValue;
    let zoomperValue = "1.25";
    if (zoomValue === 1 || zoomValue === 6) tempZoomValue = 5;
    else if (zoomValue === 2 || zoomValue === 3) {
      let zoomTextVal = zoomText != "" ? zoomText.replace("%", "") : 100;

      if (zoomTextVal > 150) {
        zoomperValue = "1.5";
        tempZoomValue = 8;
      } else if (zoomTextVal > 125) {
        zoomperValue = "1.25";
        tempZoomValue = 7;
      } else if (zoomTextVal > 100) {
        zoomperValue = "1";
        tempZoomValue = 6;
      } else if (zoomTextVal > 75) {
        zoomperValue = "0.75";
        tempZoomValue = 5;
      } else if (zoomTextVal > 50) {
        zoomperValue = "0.5";
        tempZoomValue = 4;
      } else {
        return false;
      }
    } else if (zoomValue !== 4) {
      tempZoomValue = tempZoomValue - 1;
    }
    setZoomValue(tempZoomValue);
    //setZoomClass(" r-transform" + tempZoomValue);
    setZoomClassHeight("rpdf-height" + tempZoomValue);
    if (tempZoomValue === 7) {
      zoomperValue = "1.25";
      setZoomClassFull("");
    } else if (tempZoomValue === 6) {
      zoomperValue = "1";
      setZoomClassFull("");
    } else if (tempZoomValue === 5) {
      zoomperValue = "0.75";
      setZoomClassFull("");
      //setZoomClassDiv("fixed-postion");
    } else if (tempZoomValue === 4) {
      zoomperValue = "0.5";
      setZoomClassFull("");
    } else {
      setZoomClassFull("");
      setZoomClassDiv("");
    }

    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue((orignalMainPageWidth - divImgWidth) / 2);
    setpageHeightValue(divImgHeight);

    setZoomText(zoomOptions[tempZoomValue - 1]);
  };

  const handleZoomIn = (e) => {
    resetTimer();
    var tempZoomValue = zoomValue;
    let zoomperValue = "1.25";
    if (zoomValue === 1 || zoomValue === 6) {
      tempZoomValue = 7;
    } else if (zoomValue === 2 || zoomValue === 3) {
      let zoomTextVal = zoomText != "" ? zoomText.replace("%", "") : 1;

      if (zoomTextVal < 50) {
        zoomperValue = "0.5";
        tempZoomValue = 4;
      } else if (zoomTextVal < 75) {
        zoomperValue = "0.75";
        tempZoomValue = 5;
      } else if (zoomTextVal < 100) {
        zoomperValue = "1";
        tempZoomValue = 6;
      } else if (zoomTextVal < 125) {
        zoomperValue = "1.25";
        tempZoomValue = 7;
      } else if (zoomTextVal < 150) {
        zoomperValue = "1.5";
        tempZoomValue = 8;
      } else {
        return false;
      }
    } else if (zoomValue == 5) {
      zoomperValue = "1";
      setZoomClassFull("");
      tempZoomValue = tempZoomValue + 1;
    } else if (zoomValue !== 8) {
      tempZoomValue = tempZoomValue + 1;
    }

    //computeFittingZoomGivenDimensions(false,false,window.innerWidth,window.innerHeight,pageInfo.width,pageInfo.height,zoomperValue);
    if (zoomValue == 4) {
      zoomperValue = "0.75";
      setZoomClassFull("");
    } else if (zoomValue == 5) {
      zoomperValue = "1";
      setZoomClassFull("");
    } else if (zoomValue == 6) {
      zoomperValue = "1.25";
      setZoomClassFull("");
    } else if (zoomValue == 7 || zoomValue == 8) {
      zoomperValue = "1.5";
    } else {
      setZoomClassFull("");
    }

    let pageInfo = document.getElementById("page");

    let pageOrignalWIdth = orignalPageWidth;
    let pageOrignalHeight = orignalPageHeight;

    let divImgWidth = Math.round(
      parseInt(pageOrignalWIdth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(pageOrignalHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue((orignalMainPageWidth - divImgWidth) / 2);
    setpageHeightValue(divImgHeight);

    setZoomValue(tempZoomValue);
    //setZoomClass(" r-transform" + tempZoomValue);
    setZoomClassHeight("rpdf-height" + tempZoomValue);
    console.log("Zoom in value", tempZoomValue);
    setZoomText(zoomOptions[tempZoomValue - 1]);
  };

  const handlePrint = async (e) => {
    resetTimer();
    setOpenLoader(true);
    setLoadingmessage(2);
    var rpdPrint = {
      DocumentId: documentId,
      RecpientId: tempRecipientId,
      DocumentLevelRestriction: documentLevelRestriction,
      ChkPageLevelRestriction: localPageLevelRestriction,
      PageLevelRestrictionData: documentLevelRestrictionDetails,
    };
    //let url = `${process.env.REACT_APP_API + "/docs/PrintData/" + documentId+"/"+recipientId}`;
    const url = `${process.env.REACT_APP_API}/docs/PrintData`;
    await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdPrint),
    })
      // await fetch(url, {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(rpdPrint),
      // })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        if (response.authenticated) {
          if (response.message != null && response.message == "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          }

          window.open(response.redirectUrl, "_self");
        }
        let byteCharacters = atob(response.data);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: "application/pdf;base64" });
        let fileURL = URL.createObjectURL(file);

        let divId = document.getElementById("dvframe");
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = fileURL;
        divId.appendChild(iframe);

        setTimeout(() => {
          setOpenLoader(false);
          iframe.contentWindow.print();
        }, 1000);
      })
      .catch((error) => {
        console.log("Document print read error.");
        setOpenLoader(false);
      });
  };

  const toAddressChange = async (e) => {
    setAllowResponsesTo(e.target.value);
    //this.setState({selectValue:e.target.value});
  };
  const modelPopupToClose = () => {
    setMpdelOpen(false);
  };
  const modelPopupYouDontHaveAccessClose = () => {
    setPageRestrictedFlag(false);
    setPageRestrictedCount(0);
  };
  const pageviewPopupToClose = () => {
    setPageviewModelOpen(false);
  };
  const sendToemailClose = (e) => {
    resetTimer();
    setSendEmailButton("");
    let defaultvalue = defaultToAddress;
    setAllowResponsesTo(defaultvalue);
    setreplySubject(defaultSubject);
    setreplymessage("");
  };
  const sendToEmail = async (e) => {
    resetTimer();
    setSendEmailButton("true");
    setOpenLoader(true);
    setLoadingmessage(1);
    let url = `${process.env.REACT_APP_API + "/docs/sendtoemail"}`;

    if (replySubject !== "" && replySubject.length > 255) {
      setModelMessage(API_SubjectMsg.replace("{0}", "255"));
      setSendEmailButton("");
      setMpdelOpen(true);
      setOpenLoader(false);
      return;
    } else if (replymessage !== "" && replymessage.length > 1024) {
      setModelMessage(Reader_EmailBodyMsg.replace("{0}", "1024"));
      setSendEmailButton("");
      setMpdelOpen(true);
      setOpenLoader(false);
      return;
    } else if (replySubject == "" || replySubject == null) {
      setModelMessage(Reader_PleaseEnterSubject);
      setSendEmailButton("");
      setMpdelOpen(true);
      setOpenLoader(false);
    } else {
      let data = {
        DocumentId: documentId,
        ToAddress: allowResponsesTo,
        Subject: replySubject,
        Message: replymessage,
        FromAddress: loginEmailAddress,
        RecipientId: recipientId,
      };

      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          console.log(response);
          if (response.authenticated) {
            setSendEmailButton("");
            clearTimerAndInterval();
            if (response.message != null && response.message == "declined") {
              localStorage.setItem("DeclinedVar_" + documentId, "false");
            } else {
              localStorage.setItem("DeclinedVar_" + documentId, "true");
            }

            window.open(response.redirectUrl, "_self");
          } else {
            setSendEmailButton("");
            document.getElementById("closeReplytoOwner").click();
            setModelMessage(Reader_EmailSuccessfullySent);
            setMpdelOpen(true);
            let defaultvalue = defaultToAddress;
            setAllowResponsesTo(defaultvalue);
            setreplySubject(defaultSubject);
            setreplymessage("");
            setOpenLoader(false);
          }
        })
        .catch((error) => {
          console.log("Document read error");
          setOpenLoader(false);
        });
    }
  };
  const hidemenu = (event) => {
    setShow(false);

    // disablePageNum(1);
  };
  return (
    <>
      {onlineStatus === false && (
        <div
          className="rpdFont modal"
          id="PagewModel"
          style={{
            display: "block",
            backgroundColor: "#54404061",
            zIndex: "9999999",
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="mb3" style={{ textAlign: "center" }}>
                  <img
                    src={`data:image/png;base64,${noInternetImg}`}
                    className="h-100px"
                  />
                </div>

                <h5
                  className="text-center noInternetPadding res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {Reader_InternetConnectProblem +
                    " " +
                    Reader_ConnectivityReauthenticate}
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <Translations documentId={documentId}></Translations> */}
      {openLoader ? (
        Loadingmessage == 1 ? (
          <div className="spinerAuth-text">
              <LoadingSpinner authenticatingMsg={Reader_SendingYourReply} newDesignFlag={false} />
          </div>
        ) : Loadingmessage == 2 ? (
          <div className="spinerAuth-text">
               <LoadingSpinner authenticatingMsg={Reader_LoadingPleaseWait} newDesignFlag={false} />
          </div>
        ) : (
          <div className="spinerAuth-text">
              <LoadingSpinner authenticatingMsg={Reader_LoadingPleaseWait} newDesignFlag={false} />
          </div>
        )
      ) : null}
      {/* alerts */}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        className="alerthist"
      ></Alert>
      {/* end */}
      {PageviewModelOpen === true && (
        <div
          className="rpdFont modal"
          id="PageviewModel"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <h5
                  className="text-center my-4 res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {Reader_NoUnitbalanceMessage}
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#040921",
                    }}
                    onClick={pageviewPopupToClose}
                  >
                    {Reader_OK}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <section>
        <header className="d-none" onContextMenu={(e) => e.preventDefault()}>
          <nav className="rpdFont navbar navbar-expand-md navbar-light fixed-top rpd-bg-them">
            <div className="container-fluid">
              <a className="navbar-brand p-0" href="#">
                <img src={RdocsWhite} alt="" height="45px"></img>
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="material-icons"> menu </span>
              </button>
              <div className="collapse navbar-collapse" id="navbarCollapse">
                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                  <li className="nav-item">
                    <a
                      className="nav-link  p-md-0 font20 ms-4 d-h-font"
                      aria-current="page"
                      href="#"
                      style={{ color: "#ffffff", fontWeight: "500" }}
                    >
                      {Reader_DigitalRightsManagement}
                    </a>
                  </li>
                </ul>
                <form className="d-sm-none d-md-block">
                  <ul className="navbar-nav d-flex align-items-center res-w100 resalign-items-start me-auto mb-2 mb-md-0">
                    <li className="nav-item res-w100">
                      <a className="nav-link p-0" href="#">
                        <img
                          src={RpostPowered}
                          alt=""
                          className="h-52p"
                          id="hiddenclickimg"
                        />
                      </a>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </nav>
        </header>

        {/* Index Header */}
        <header onContextMenu={(e) => e.preventDefault()}>
          <nav className="rpdFont navbar navbar-expand-md navbar-light fixed-top rpd-bg-them">
            <div className="container-fluid">
              <a
                className="navbar-brand p-0"
                href={
                  SessionpopuupDisable == 0
                    ? "https://rpostdocs.io/"
                    : undefined
                }
                target="_blank"
              >
                <img src={RdocsWhite} alt="" height="45px"></img>
              </a>

              <button
                //   onClick="imageClick()"
                className="navbar-toggler"
                type="button"
                onClick={() => setShow(!show)}
              >
                <span className="material-icons text-white"> menu </span>
              </button>
              <div
                className="collapse navbar-collapse"
                style={show ? { display: "block" } : { display: "none" }}
                id="navbarCollapse"
              >
                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                  <li className="nav-item">
                    <a
                      className="rpdFont nav-link p-md-0 font20 ms-4 font-500"
                      aria-current="page"
                      style={{ color: "#ffffff" }}
                      onClick={(e) => hidemenu(show)}
                    >
                      {Reader_ProtectedDocumentViewer}
                    </a>
                  </li>
                </ul>
                <form className="d-sm-none d-md-block">
                  <ul className="navbar-nav d-flex align-items-center res-w100 resalign-items-start me-auto mb-2 mb-md-0">
                    <li className="nav-item res-w100">
                      <a
                        className="nav-link p-0"
                        href={
                          SessionpopuupDisable == 0
                            ? "https://rpost.com/"
                            : undefined
                        }
                        target="_blank"
                      >
                        <img
                          src={RpostPowered}
                          alt="Logo"
                          className="h-52p"
                          id="hiddenclickimg"
                        ></img>
                      </a>
                    </li>
                  </ul>
                </form>

                <form className="d-sm-block d-md-none parentscroll-menu">
                  <ul className="navbar-nav d-flex  res-w100 resalign-items-start me-auto mb-2 mb-md-0 scroll-menu">
                    {isVoting === true && (
                      <li className="nav-item dropdown res-w100 res-border">
                        <a
                          className="rpdFont nav-link dropdown-toggle active d-flex text-white"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal2"
                          href="/#"
                          alt="Voting"
                          onClick={(e) => hidemenu(show)}
                        >
                          <span
                            className={
                              (VotedValue === -1
                                ? "thumsMColor "
                                : VotedValue === 0
                                  ? "thumsDownColor "
                                  : "thumsUpColor ") + "material-icons text-white"
                            }
                          >
                            {" "}
                            {VotedValue === 0
                              ? "thumb_down_alt"
                              : "thumb_up_alt"}{" "}
                          </span>
                          <span className="rpdFont ms-3 d-sm-block d-md-none text-white">
                            {Reader_Voting}
                          </span>
                        </a>
                      </li>
                    )}
                    {isDistributionList === true && (
                      <li className="nav-item dropdown res-w100 res-border">
                        <a
                          className="nav-link d-flex active dropdown-toggle text-white"
                          data-bs-toggle="dropdown"
                          href="/#"
                        >
                          <span className="material-icons text-white">
                            {" "}
                            people{" "}
                          </span>
                          <span
                            className="rpdFont ms-3 d-sm-block d-md-none"
                            style={{ color: "#ffffff" }}
                          >
                            {Reader_DistributionList}
                          </span>
                        </a>

                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box xerox-h300"
                          style={{ background: "#9e9e9e3d" }}
                        >
                          <li>
                            <p className="rpdFont note mb-0 dropdown-item text-white">
                              {Reader_UsersList}
                            </p>
                          </li>
                          {userlist.map((item, idex) => (
                            <li>
                              <p
                                className="dropdown-item mb-0 d-flex align-items-start rpdFont text-white"
                                href="/#"
                              >
                                {item.email}
                                {item.vote === 1 && (
                                  <span
                                    className="material-icons ms-2 text-white"
                                    style={{ color: "rgb(58, 177, 109)" }}
                                  >
                                    thumb_up_alt
                                  </span>
                                )}
                                {item.vote === 0 && (
                                  <span
                                    className="material-icons ms-2 text-white"
                                    style={{ color: "#c3272e" }}
                                  >
                                    thumb_down_alt
                                  </span>
                                )}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}
                    {isSideNote && (
                      <li className="dropdown nav-item res-w100 res-border">
                        <a
                          className="nav-link d-flex active dropdown-toggle text-white"
                          data-bs-toggle="dropdown"
                          href="/#"
                        >
                          <span className="material-icons text-white">
                            {" "}
                            chat{" "}
                          </span>
                          <span
                            className="rpdFont ms-3 d-sm-block d-md-none"
                            style={{ color: "#fff" }}
                          >
                            {Reader_SideNote}
                            <super className="superfont-10 text-white">®</super>
                          </span>
                        </a>

                        <ul
                          className="rpdFont dropdown-menu dropdown-menu-end arrow_box1"
                          style={{ background: "#9e9e9e3d" }}
                        >
                          <li>
                            <div className="d-flex flex-wrap">
                              <p className="rpdFont note dropdown-p mb-0 d-flex text-white">
                                <label> {Reader_NoteFrom}&nbsp;</label>

                                <label className="them-color mt-0 mb-0 font-500 text-white">
                                  {senderEmailAddress}
                                </label>
                              </p>
                            </div>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <p className="rpdFont text-white dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 font-16">
                              {docNote}
                            </p>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isallowResponsesTo && (
                      <li className="nav-item res-w100 res-border">
                        <a
                          className="rpdFont text-white nav-link d-flex active"
                          href="/#"
                          data-bs-toggle="modal"
                          data-bs-target="#replyToOwnerModel"
                          onClick={(e) => hidemenu(show)}
                        >
                          <span className="material-icons text-white">
                            {" "}
                            drafts{" "}
                          </span>
                          <span className="rpdFont text-white ms-3 d-sm-block d-md-none">
                            {Reader_ReplyToDocument}
                          </span>
                        </a>
                      </li>
                    )}
                    {isPrint   && (
                      <li className="nav-item res-w100 res-border">
                        <a
                          className={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages == totalPages?"rpdFont text-white nav-link d-flex active disabledPrint":"rpdFont text-white nav-link d-flex active"}
                          onClick={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages == totalPages?null:handlePrint}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="material-icons text-white">
                            {" "}
                            print{" "}
                          </span>
                          <span className="ms-3 d-sm-block d-md-none text-white">
                            {Reader_Print}
                          </span>
                        </a>
                      </li>
                    )}
                    <li className="rpdFont text-white dropdown nav-item res-w100 res-border">
                      <a
                        className="nav-link d-flex align-items-center active dropdown-toggle"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        href={void 0}
                      >
                        <span className="material-icons text-white">
                          {" "}
                          info{" "}
                        </span>
                        <span className="rpdFont text-white ms-3 d-sm-block d-md-none">
                          More Information
                        </span>
                      </a>

                      <ul
                        className="rpdFont text-white dropdown-menu dropdown-menu-end arrow_box1"
                        style={{ background: "#9e9e9e3d" }}
                      >
                        <li>
                          <div className="d-flex flex-wrap">
                            <p className="RobotoFont note xerox-p d-flex dropdown-p mb-0">
                              <label
                                className="rpdFont text-white mt-0 mb-0"
                                style={{
                                  fontWeight: "500",
                                  color: "#fff",
                                }}
                              >
                                {Reader_ID}{" "}{documentId}
                              </label>
                            </p>
                          </div>
                        </li>
                        {/* <li>
                            <hr className="dropdown-divider" />
                          </li> */}
                        {
                          <TimerDisplay
                            reader_viewTime={Reader_viewTime}
                            class={
                              "rpdFont text-white dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                            }
                            styles={'fontSize: "16px",color: "#fff"'}
                          ></TimerDisplay>
                          // <li>
                          //   <p
                          //     className="rpdFont text-white dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                          //     style={{fontSize: "16px",color: "#fff"}}
                          //   >
                          //     {Reader_viewTime}
                          //     {" (hh:mm:ss)"}: {convertToHHMMSS(viewDocTime)}
                          //     {/* {viewDocTime === 1 ? "Min" : "Mins"} */}
                          //   </p>
                          // </li>
                        }
                      </ul>
                    </li>
                    <li className="nav-item res-w100 dropdown">
                      <a
                        className="nav-link text-white d-flex active dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="/#"
                      >
                        <span className="material-icons text-white">
                          {" "}
                          zoom_out_map{" "}
                        </span>
                        <span className="ms-3 d-sm-block d-md-none text-white">
                          {Reader_Zoom}
                        </span>
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end arrow_box"
                        style={{
                          background: "#9e9e9e3d",
                          maxHeight: "200px",
                          overflow: "auto",
                        }}
                      >
                        <li>
                          <button
                            type="button"
                            className="dropdown-item rpdFont text-white"
                            value={1}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "100%", "1")
                            }
                          >
                            {Reader_ActualSize}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={2}
                            onClick={(e) =>
                              handleMobileZoomDropdown(
                                e,
                                zoomPercentage + "%",
                                "FitPage"
                              )
                            }
                          >
                            {Reader_FitPage}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={3}
                            onClick={(e) =>
                              handleMobileZoomDropdown(
                                e,
                                zoomPercentage + "%",
                                "FullWidth"
                              )
                            }
                          >
                            {Reader_FullWidth}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={4}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "50%", "0.5")
                            }
                          >
                            50%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={5}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "75%", "0.75")
                            }
                          >
                            75%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={6}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "100%", "1")
                            }
                          >
                            100%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={7}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "125%", "1.25")
                            }
                          >
                            125%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={8}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "150%", "1.5")
                            }
                          >
                            150%
                          </button>
                        </li>
                      </ul>
                    </li>
                    {documentLevelRestriction && (
                    <li className="rpdFont dropdown nav-item">
                      <div
                        className="form-check checkbox-theme justify-content-center"
                        style={{ textAlign: "center", paddingTop: "0.3rem", paddingLeft: "0px", marginLeft: "-2px" }}
                      >
                        <input
                          className="chkAllowReaders"
                          type="checkbox"
                          value={localPageLevelRestriction}
                          checked={localPageLevelRestriction}

                          id="robot"
                          onChange={(e) => { handleChkChange(e) }}
                        />
                        <label className="form-check-label" htmlFor="rememberMe" style={{ paddingLeft: ".7rem",verticalAlign: "text-bottom" }}>
                          {Reader_AllowedPagesOnly}
                        </label>
                      </div>
                    </li>
                    )}
                  </ul>
                </form>
              </div>
            </div>
          </nav>
        </header>
      </section>
      <main
        className={pageLevelRestriction ? "rpdFont flex-shrink-0 min-vh-94" : "rpdFont flex-shrink-0 min-vh-95"}
        style={{ background: "#9a9a9a" }}
        onContextMenu={(e) => e.preventDefault()}
        id="mainPageView"
        onClick={(e) => hidemenu(show)}
      >
        <div
          className="container-fluid r-fixed-div"
          style={{ background: "#f3f3f3" }}
        >
          <div className="rpdFont row justify-content-center resmx-1 d-h-font">
            <div className="col-12 col-md-12 col-lg-12 col-xl-8">
              <div
                className="d-flex align-items-center justify-content-between resjustify-center top-n-1"
                id="iconsMenu"
              >
                <div
                  className="btn-toolbar d-sm-none d-md-block"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <div
                    className="btn-group rpd-btngroup"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      type="button"
                      className=" btn btn-outline-secondary rpd-btncolor"
                      // className={ zoomClassDisabled != "" ? " btn btn-outline-secondary rpd-btncolor " + zoomClassDisabled : " btn btn-outline-secondary rpd-btncolor" }
                      onClick={(e) => handleZoomOut(e)}
                      disabled={pageLevelRestriction}
                    >
                      <span className="material-icons"> zoom_out </span>
                    </button>
                    <button
                      type="button"
                      className="rpdFont btn btn-outline-secondary rpd-btncolor customeborder  mn-wd-55"
                      disabled={pageLevelRestriction}
                    >
                      {zoomText}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary  rpd-btncolor customeborder"
                      onClick={(e) => handleZoomIn(e)}
                      disabled={pageLevelRestriction}
                    >
                      <span className="material-icons"> zoom_in </span>
                    </button>
                    <div className="btn-group">
                      <button
                        type="button"
                        className="rpdFont btn btn-outline-secondary rpd-btncolor dropdown-toggle customeborder bg-black"
                        data-bs-toggle="dropdown"
                        disabled={pageLevelRestriction}
                      >
                        <span className="material-icons"> expand_more </span>
                      </button>
                      <ul className="dropdown-menu rpddropdown">
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={1}
                            onClick={(e) => handleZoomDropdown(e, "100%", "1")}
                          >
                            {Reader_ActualSize}
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={2}
                            onClick={(e) =>
                              handleZoomDropdown(
                                e,
                                zoomPercentage + "%",
                                "FitPage"
                              )
                            }
                          >
                            {Reader_FitPage}
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={3}
                            onClick={(e) =>
                              handleZoomDropdown(
                                e,
                                zoomPercentage + "%",
                                "FullWidth"
                              )
                            }
                          >
                            {Reader_FullWidth}
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={4}
                            onClick={(e) => handleZoomDropdown(e, "50%", "0.5")}
                          >
                            50%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={5}
                            onClick={(e) =>
                              handleZoomDropdown(e, "75%", "0.75")
                            }
                          >
                            75%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={6}
                            onClick={(e) => handleZoomDropdown(e, "100%", "1")}
                          >
                            100%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={7}
                            onClick={(e) =>
                              handleZoomDropdown(e, "125%", "1.25")
                            }
                          >
                            125%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={8}
                            onClick={(e) =>
                              handleZoomDropdown(e, "150%", "1.5")
                            }
                          >
                            150%
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="rpd-btngroup">
                  <div
                    className="btn-toolbar d-flex align-items-center"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="First group"
                      style={{ backgroundColor: "#040921" }}
                    >
                      <button
                        type="button"
                        id="btnPrevMin"
                        className={
                          (currentpage === 1
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary btn-page-navi rpd-btn first"
                        }
                        style={{ backgroundColor: "#040921" }}
                        onClick={handlePreviousMinWrap}
                      >
                        <span className="material-icons text-white  top-n2">
                          {" "}
                          first_page{" "}
                        </span>
                      </button>
                    </div>
                    <div
                      className="btn-group ms-1"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        type="button"
                        id="btnPrev"
                        className={
                          (currentpage === 1
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary lborder rpd-btn rpd-btn2"
                        }
                        onClick={handlePreviousChangeWrapper}
                      >
                        <span className="material-icons"> chevron_left </span>
                      </button>
                    </div>

                    <div className="rpdFont d-flex align-items-center justify-content-center">
                      <div className="d-flex align-items-center m-auto justify-content-center ms-2">
                        <input
                          type="text"
                          ref={totalPagesRef}
                          className={
                            (disablePageNavigationButtons == true
                              ? " disabled "
                              : "") + "form-control text-box"
                          }
                          value={currentTempPage}
                          onChange={(e) =>
                            handlePageNumChange(e.target.value)
                          }
                          onBlur={(e) => handleBlurPageNumChangeWrapper()}
                          onKeyDown={handleKeyDownPageNumChange}
                        />
                      </div>

                      <p
                        className="ms-2 me-2 mb-0 font17"
                        style={{ color: "black" }}
                      >
                        / {totalPages}
                      </p>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        type="button"
                        id="btnNxt"
                        className={
                          (currentpage === totalPages
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary rpd-btn2 rborder rpd-btn"
                        }
                        onClick={(e) => {
                          handleNextChangeWrapper(e);
                        }}
                      >
                        <span className="material-icons"> navigate_next </span>
                      </button>
                    </div>
                    <div
                      className="btn-group ms-1"
                      role="group"
                      aria-label="First group"
                      style={{ backgroundColor: "#040921" }}
                    >
                      <button
                        type="button"
                        id="btnNxtMax"
                        className={
                          (currentpage === totalPages
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary rpd-btn btn-page-navi last"
                        }
                        style={{ backgroundColor: "#040921" }}
                        onClick={handleNextMaxWrap}
                      >
                        <span className="material-icons text-white  top-n2">
                          {" "}
                          last_page{" "}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center d-sm-none d-md-block">
                  <ul className="no-bullets">
                    {isVoting === true && (
                      <li className="nav-item dropdown res-w100">
                        <a
                          className="r-nav-link dropdown-toggle"
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal2"
                          data-toggle="tooltip"
                          title={Reader_ClickToVote}
                        >
                          <span
                            className={
                              (VotedValue === -1
                                ? "thumsColor1 "
                                : VotedValue === 0
                                  ? "thumsDownColor "
                                  : "thumsUpColor ") + "material-icons"
                            }
                          >
                            {" "}
                            {VotedValue === 0
                              ? "thumb_down_alt"
                              : "thumb_up_alt"}{" "}
                          </span>
                        </a>

                        <ul className="rpdFont dropdown-menu dropdown-menu-end arrow_box">
                          <li>
                            <p className="note dropdown-item mb-2">
                              {Reader_Voting}:
                            </p>
                          </li>
                          <li>
                            <a
                              className="dropdown-item border border-bottom-1 d-flex align-items-center"
                              href="#"
                            >
                              <span
                                className="material-icons me-2"
                                style={{
                                  color: "rgb(58, 177, 109)",
                                  fontSize: "20px",
                                }}
                              >
                                thumb_up
                              </span>
                              {Reader_Like}
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item border d-flex align-items-center border-bottom-0"
                              href="#"
                            >
                              <span
                                className="material-icons me-2"
                                style={{ color: "#c3272e", fontSize: "20px" }}
                              >
                                thumb_down
                              </span>
                              {Reader_Dislike}
                            </a>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isDistributionList === true && (
                      <li className="rpdFont nav-item dropdown res-w100">
                        <a
                          className="rpdFont r-nav-link dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="#"
                          data-toggle="tooltip"
                          title={Reader_ViewDistributionList}
                        >
                          <span className="material-icons"> people </span>
                        </a>

                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box2"
                          style={{
                            position: "absolute",
                            inset: "0px auto auto 0px",
                            margin: "0px",
                            transform: "translate(-211px, 45px)",
                            padding: "0px",
                            maxHeight: "350px",
                            overflow: "auto",
                            whiteSpace: "initial",
                            minWidth: "300px",
                            maxWidth: "350px",
                          }}
                        >
                          <li>
                            <p
                              className="rpdFont note mb-0 dropdown-item"
                              style={{ color: "rgb(4, 9, 33)" }}
                            >
                              {Reader_DistributionList}:
                            </p>
                          </li>
                          {userlist.map((item, idex) => (
                            <li>
                              <p
                                className="rpdFont dropdown-item border border-bottom-1 d-flex align-items-start wordwrap"
                                style={{ marginBottom: "0px" }}
                              >
                                {(item.firstName || item.lastName) && (
                                  <span className="spanAlign">
                                    {item.firstName} {item.lastName}
                                    <br />
                                    {`<${item.email}>`}
                                  </span>
                                )}
                                {!item.firstName && !item.lastName && (
                                  <span className="spanAlign">
                                    {item.email}
                                  </span>
                                )}
                                {item.vote === 1 && (
                                  <span
                                    className="material-icons ms-2"
                                    style={{ color: "rgb(58, 177, 109)" }}
                                  >
                                    thumb_up_alt
                                  </span>
                                )}
                                {item.vote === 0 && (
                                  <span
                                    className="material-icons ms-2"
                                    style={{ color: "#c3272e" }}
                                  >
                                    thumb_down_alt
                                  </span>
                                )}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}
                    {isSideNote && (
                      <li className="rpdFont dropdown nav-item res-w100">
                        <a
                          className="rpdFont r-nav-link dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="/#"
                          data-toggle="tooltip"
                          title={Reader_ViewSideNote}
                        >
                          <span className="material-icons"> chat </span>
                        </a>

                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box2"
                          style={{ minWidth: "22rem", maxWidth: "300px" }}
                        >
                          <li>
                            <div className="rpdFont d-flex flex-wrap">
                              <p className="rpdFont note dropdown-p mb-0 d-flex">
                                <label style={{ color: "rgb(4, 9, 33)" }}>
                                  {" "}
                                  {Reader_SideNote}
                                  <super className="superfont-10">®</super>
                                  :&nbsp;
                                </label>

                                <label
                                  className="rpdFont them-color mt-0 mb-0 wordwrap"
                                  style={{ fontWeight: "500" }}
                                >
                                  {senderEmailAddress}
                                </label>
                              </p>
                            </div>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <p
                              className="rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                              style={{
                                fontSize: "16px",
                                maxHeight: "350px",
                                overflow: "auto",
                                whiteSpace: "initial",
                              }}
                            >
                              {docNote}
                            </p>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isallowResponsesTo && (
                      <li className="rpdFont nav-item res-w100">
                        <a
                          className="rpdFont r-nav-link"
                          style={{ cursor: "pointer" }}
                          data-bs-toggle="modal"
                          data-bs-target="#replyToOwnerModel"
                          data-toggle="tooltip"
                          title={Reader_ReplyToDocument}
                        >
                          <span className="material-icons"> drafts </span>
                          <span className="ms-3 d-sm-block d-md-none">
                            {Reader_ReplyToDocument}
                          </span>
                        </a>
                      </li>
                    )}
                    {isPrint  && (
                      <li className={ "rpdFont rpdFont nav-item res-w100"}>
                        <a
                          className={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages?"rpdFont r-nav-link disabledPrint" : "rpdFont r-nav-link dis"}
                          style={{ cursor: "pointer" }}
                          data-bs-toggle="modal"
                          onClick={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages? null:handlePrint}
                          data-toggle="tooltip"
                          title={Reader_ClickToPrint}
                        >
                          <span className="material-icons"> print </span>
                          <span className="ms-3 d-sm-block d-md-none">
                            {Reader_Print}
                          </span>
                        </a>
                      </li>
                    )}
                    <li className="rpdFont dropdown nav-item res-w100">
                      <a
                        className="rpdFont r-nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="/#"
                        data-toggle="tooltip"
                      // title="Document info"
                      >
                        <span
                          className="material-icons"
                          style={{ color: "#040921" }}
                        >
                          {" "}
                          info{" "}
                        </span>
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end arrow_box2"
                        style={{
                          minWidth: "22rem",
                          maxWidth: "200px",
                          maxHeight: "110px",
                        }}
                      >
                        <li>
                          <div className="rpdFont d-flex flex-wrap justify-content-end">
                            <p
                              className="rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                              style={{
                                fontSize: "16px",
                                maxHeight: "350px",
                                overflow: "auto",
                                whiteSpace: "initial",
                                color: "black !important",
                                display: "none",
                              }}
                            >
                              {Reader_ID}
                              <span style={{ display: "block" }}>
                                &nbsp;{documentId}
                              </span>
                            </p>
                          </div>
                        </li>
                        {
                          <TimerDisplay
                          reader_viewTime={Reader_RPostviewTime}
                            class={
                              "rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                            }
                            styles={
                              'fontSize: "16px",maxHeight: "350px",overflow: "auto",whiteSpace: "initial",display: "none"'
                            }
                          ></TimerDisplay>
                          // <li>
                          //   <p
                          //     className="rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                          //     style={{fontSize: "16px",maxHeight: "350px",overflow: "auto",whiteSpace: "initial",display: "none"}}
                          //   >
                          //     {Reader_viewTime}
                          //     {" (hh:mm:ss)"}: {convertToHHMMSS(viewDocTime)}
                          //     {/* {viewDocTime === 1 ? "Min" : "Mins"} */}
                          //   </p>
                          // </li>
                        }
                      </ul>
                    </li>
                    {documentLevelRestriction && (
                      <li className="rpdFont dropdown nav-item res-w100">
                        <div
                          className="form-check checkbox-theme justify-content-center"
                          style={{ textAlign: "center", paddingTop: "0.3rem", paddingLeft: "0px" }}
                        >
                          <input
                            className="chkAllowReaders"
                            type="checkbox"
                            value={localPageLevelRestriction}
                            checked={localPageLevelRestriction}

                            id="robot"
                            onChange={(e) => { handleChkChange(e) }}
                          />
                          <label className="form-check-label" htmlFor="rememberMe" style={{ paddingBottom: "2px", verticalAlign: "text-bottom" }}>
                            {Reader_AllowedPagesOnly}
                          </label>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <>
          {!pageLevelRestriction && (
            <Container
              className={
                zoomClassFull != ""
                  ? " no-visual-search d-flex " + zoomClassFull
                  : "no-visual-search d-flex"
              }
            >
              {imgURLData != "" && (
                <img
                  className={zoomClass + " rm-trans"}
                  id="page"
                  src={`data:image/png;base64,${imgURLData}`}
                  alt={imgURLData == "" ? "Page Not Found" : ""}
                  align="left"
                  style={{ width: pageWidthValue, height: pageHeightValue }}
                  onLoad={handlePageOnload}
                />
              )}
              <div
                className="watermarkParent"
                style={{
                  width: pageWidthValue,
                  height: pageHeightValue,
                  marginLeft: pageWidthLeftValue,
                }}
              >
                <div
                  className="watermark noselect "
                  dangerouslySetInnerHTML={{ __html: identifyLeakerText }}
                ></div>
              </div>

            </Container>
          )}
        </>
        {pageLevelRestriction && (
          <Container
            className={
              zoomClassFull != ""
                ? " no-visual-search d-flex fixed-postion " + zoomClassFull
                : "no-visual-search d-flex fixed-postion"
            }
          >
            <WhitePage rpdBody={document.getElementById("rpdBody")} Reader_YouDontHaveAccess={Reader_YouDontHaveAccess} ></WhitePage>
          </Container>
        )}
      </main>


      {/* Modal popup */}
      {open === true && (
        <div
          backdrop="static"
          className="rpdFont modal"
          id="myModal1"
          style={{
            display: "block",
            backgroundColor: "rgb(114 114 114 / 28%)",
            zIndex: "999999",
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div
            className="rpdFont modal-dialog modal-dialog-centered modal-customelg"
            style={{ background: "transparent" }}
          >
            <div className="modal-content">
              <div className="modal-body d-flex flex-column">
                <div className="mt-4 mb-3 justify-content-center d-flex">
                  <img src={timerpng} alt="Time" className="check" />
                </div>

                <h5
                  className="rpdFont text-center my-2 res-font14"
                  style={{ color: "rgb(4, 9, 33)" }}
                >
                  {Reader_RPDYouHaveBeenInactive}
                </h5>
                <h6
                  className="rpdFont text-center mb-1"
                  style={{ color: "rgb(4, 9, 33)", fontSize: "17px" }}
                >
                  {Reader_ContinueReadingDocument}
                </h6>
                {/* <label id="spntimer" className="text-center" style={{paddingLeft:"50px"}}>4 minute(s) & 59 second(s)</label> */}
                <label
                  id="spntimer"
                  className="text-center mb-1"
                  style={{
                    color: "rgb(4, 9, 33)",
                    fontSize: "17px",
                  }}
                >
                  {Reader_YouWillbeLoggedOutIn}{" "}
                  {minutesVal +
                    " " +
                    Reader_minutesSmall +
                    " " +
                    secondsVal +
                    " " +
                    Reader_secondsSmall}
                </label>
                <div className="mt-3 mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{ background: "rgb(4, 9, 33)" }}
                    onClick={handleToClose}
                  >
                    {Reader_Continue}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className="rpdFont modal "
        id="myModal2"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="rpdFont modal-dialog modal-dialog-centered modal-customelg">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-end mt-1 border-0 pb-0">
              <button
                type="button"
                className="btn btn-outline-danger modalclose rpdclose"
                data-bs-dismiss="modal"
              >
                {" "}
                <span className="material-icons font-20">
                  highlight_off
                </span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3 justify-content-center d-flex">
                <img
                  src={
                    VotedValue === -1
                      ? likeUnlike
                      : VotedValue === 0
                        ? Unlike
                        : likelike
                  }
                  alt=""
                  className="modalcheck"
                />
              </div>
              <h5
                className="text-center mt-4 mb-2"
                style={{
                  color: "#040921",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                {Reader_ConfirmYourVote}
              </h5>
              <h6
                className="text-center mb-4"
                style={{ color: "#040921", fontSize: "17px" }}
              >
                {Reader_OnlyVoteOnce}
              </h6>
              <div className="pt-2 mb-3 justify-content-center d-flex">
                <button
                  type="button"
                  disabled={VotedValue === -1 ? false : true}
                  className="btn btn-success d-flex align-items-center px-4"
                  style={{ backgroundColor: "rgb(58, 177, 109) !important" }}
                  data-bs-dismiss="modal"
                  onClick={(e) => handleToLike(e)}
                >
                  <span className="material-icons me-1"> thumb_up </span>{" "}
                  {Reader_Like}
                </button>
                <button
                  type="button"
                  disabled={VotedValue === -1 ? false : true}
                  className="btn btn-danger ms-4 d-flex align-items-center px-3"
                  style={{ backgroundColor: "#c3272e" }}
                  data-bs-dismiss="modal"
                  onClick={(e) => handleToUnLike(e)}
                >
                  <span className="material-icons me-1"> thumb_down </span>{" "}
                  {Reader_Dislike}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="rpdFont modal"
        id="replyToOwnerModel"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="modal-dialog modal-dialog-centered modal-customelg">
          <div className="modal-content">
            <div className="modal-header pb-2">
              <h5 className="Rreply-text"> {Reader_ReplyToDocument} </h5>
              <button
                type="button"
                className="btn btn-outline-danger modalclose rpdclose"
                data-bs-dismiss="modal"
                id="closeReplytoOwner"
                onClick={(e) => sendToemailClose(e)}
              >
                <span className="material-icons font-20">highlight_off</span>{" "}
              </button>
            </div>

            <div className="rpdFont modal-body">
              <div className="input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rpd-group-text">
                    <i className="material-icons" style={{ fontSize: "22px" }}>
                      contact_mail
                    </i>
                  </span>
                </div>
                <input
                  id="txtToAddress"
                  readOnly={true}
                  type="text"
                  className="rpdFont form-control input_user"
                  placeholder={Reader_ToAddress}
                  value={allowResponsesTo}
                  onChange={(e) => setAllowResponsesTo(e.target.value)}
                ></input>
              </div>

              <div className="input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rpd-group-text">
                    <i className="material-icons" style={{ fontSize: "22px" }}>
                      subject
                    </i>
                  </span>
                </div>
                <input
                  id="txtSubject"
                  type="text"
                  name="subject"
                  className="rpdFont form-control input_user"
                  placeholder={Reader_Subject}
                  value={replySubject}
                  onChange={(e) => setreplySubject(e.target.value)}
                ></input>
              </div>

              <div>
                <textarea
                  name="replymessage"
                  className="rpdFont form-control font-w600 rplycontrol"
                  rows="4"
                  style={{ resize: "none" }}
                  placeholder={Reader_Message}
                  value={replymessage}
                  onChange={(e) => setreplymessage(e.target.value)}
                ></textarea>
              </div>

              <div className="pt-2 my-3 justify-content-center d-flex">
                <button
                  type="button"
                  disabled={sendEmailButton}
                  className="btn btn-secondary cpx-5 cpy-1 w-50 rp-btn"
                  style={{
                    backgroundColor: "#040921 !important",
                    color: "white !important",
                    border: "1px solid #040921",
                  }}
                  onClick={(e) => sendToEmail(e)}
                >
                  {Reader_Send}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {senderEmailAddress.indexOf("@xerox.com") === -1 && (
        <div
          className={
            zoomClassFull != ""
              ? "mobile-footer " + zoomClassFull
              : "mobile-footer"
          }
          onClick={(e) => hidemenu(show)}
        >
          <Footer
            Reader_GeneralTermsFooter={Reader_GeneralTermsFooter}
            Reader_LegalNotices={Reader_LegalNotices}
            Reader_ClickServiceLevelTerms={Reader_ClickServiceLevelTerms}
            Reader_Patent={Reader_Patent}
            Reader_OtherService={Reader_OtherService}
            className="pdf-footer"
            onContextMenu={(e) => e.preventDefault()}
          ></Footer>
        </div>
      )}

      {modelopen === true && (
        <div
          className="rpdFont modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <h5
                  className="text-center my-4 res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {modelMessage}
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#040921",
                    }}
                    onClick={modelPopupToClose}
                  >
                    {Reader_OK}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      { pageRestrictedFlag == true && (
        <div
          className="rpdFont modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex align-items-center flex-column justify-content-center bg-white" >
                  <img className="mb-4"
                    src={`data:image/png;base64,${imgLockData}`}
                    //src="https://cdn-icons-png.flaticon.com/512/12478/12478122.png"
                    width="80" height="80" alt="File lock free icon" title="File lock free icon"></img>
                  <h6 className="imgLockText">{Reader_YouDontHaveAccessToRequested}</h6>
                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#040921",
                    }}
                    onClick={modelPopupYouDontHaveAccessClose}
                  >
                    {Reader_OK} {" ("}{pageRestrictedCount}{")"}
                  </button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div id="dvframe" style={{ display: "none" }}></div>
    </>
  );
}
export default DocumentNew;
